<template>
  <div class="profile-page">
    <transition name="fade-slide">
      <div v-if="isLoading" class="global-loader">
        <div class="loader-spinner"></div>
        <p>Loading...</p>
      </div>
    </transition>

    <!-- ==============================
            HEADER + BANNER
    =============================== -->
    <div class="profile-header" style="margin-bottom: 1rem;">

      <!-- ===== BANNER ===== -->
      <div class="banner-box">
        <img :src="profile.banner" class="banner-img" />
        <label v-if="isEdit" class="banner-upload-bar" style="padding-left: 40%;">
          <i class="bx bx-image-add"></i> Upload a new banner (1080 × 360)
          <input type="file" hidden @change="uploadBanner" />
        </label>
      </div>

      <!-- TOP ROW: AVATAR + NAME + BUTTON -->
      <div class="profile-top-row">

        <!-- LEFT SIDE -->
        <div class="header-left-stack">

          <!-- Avatar -->
          <div class="avatar-container">
            <img :src="profile.avatar" class="avatar-img" />
            <label v-if="isEdit" class="avatar-edit-icon">
              <i class="bx bx-camera"></i>
              <input type="file" hidden @change="uploadAvatar" />
            </label>
          </div>

          <!-- Name & Rating -->
          <div class="info-stack">

            <div class="name-line">
              <h2>{{ profile.name }}</h2>
              <i v-if="profile.verified" class="bx bx-check-circle verified-icon"></i>
            </div>

            <div class="rating-line" style="height: 1.5rem;">
              <!-- <i class="bx bxs-star star-icon"></i>
              <span class="rating-value">{{ profile.rating }}</span>
              <span class="rating-count">({{ profile.reviewCount }})</span> -->
            </div>

            <!-- <span class="availability-pill">{{ profile.availability }}</span> -->

          </div>
        </div>

        <!-- RIGHT SIDE BUTTONS -->
        <div class="header-contact-col">
          <button class="contact-btn" v-if="isEdit" @click="saveProfile" style="margin-right: 1rem;">
            <i class="bx bx-edit"></i>
            Save
          </button>
          <button class="contact-btn" v-if="isEditorMode" @click="editToggleNow" style="margin-right: 1rem;">
            <i v-if="isEdit" class="bx bx-show"></i>
            <i v-if="!isEdit" class="bx bx-edit"></i>
            {{isEdit ? "Preview" : "Edit"}}
          </button>

          <button v-if="!isEdit" class="contact-btn" @click="openContactModal">
            <i class="bx bx-message-rounded"></i> Contact
          </button>

          <button v-if="!isEdit && isEditorMode && profile.status!='Live'" class="contact-btn"
            @click="exportAndPublishHTML" style="margin-left: 1rem;">
            <i class="bx bx-share-alt"></i> Publish Page
          </button>
          <button v-if="!isEdit && isEditorMode && profile.status=='Live'" class="contact-btn" @click="copyLink"
            style="margin-left: 1rem;">
            <i class="bx bx-share-alt"></i> Copy Link
          </button>
        </div>

      </div>

      <!-- PREVIEW EXTRA INFO -->
      <div v-if="!isEdit" class="header-extra-details">

        <div class="card" v-if="!isEdit">

          <h3>Details</h3>
          <div class="detail-row" v-if="profile.camera">
            <span class="label">Gender</span>
            <span>{{ profile.gender }}</span>
          </div>
          <div class="detail-row" v-if="profile.camera">
            <span class="label">Languages</span>
            <span>{{ profile.languages.join(", ") }}</span>
          </div>
          <div class="detail-row" v-if="profile.camera">
            <span class="label">Camera</span>
            <span>{{ profile.camera }}</span>
          </div>

          <div class="detail-row" v-if="profile.industries.length">
            <span class="label">Industries</span>
            <span class="industry-value">{{ profile.industries.join(", ") }}</span>
          </div>

          <div class="detail-row" v-if="profile.equipment.length">
            <span class="label">Equipment</span>
            <span class="industry-value">{{ profile.equipment.join(", ") }}</span>
          </div>

          <!-- <div class="detail-row" v-if="profile.filming.length">
            <span class="label">Filming</span>
            <span>{{ profile.filming.join(", ") }}</span>
          </div>

          <div class="detail-row" v-if="profile.pets.length">
            <span class="label">Pets</span>
            <span>{{ profile.pets.join(", ") }}</span>
          </div> -->
          <div class="detail-row" v-if="profile.location">
            <span class="label">Location</span>
            <span>{{ profile.location }}</span>
          </div>
          <br>
          <p>{{ shortDescription }}</p>
        </div>
        <br>
        <!-- BRAND LOGOS (PREVIEW MODE) -->
        <div class="card" v-if="!isEdit && profile.brandLogos.length">

          <h3>Brands that have trusted me</h3>

          <div class="brand-logo-grid">
            <img v-for="(b,i) in profile.brandLogos" :key="i" :src="base_url + b" class="brand-logo-img" />
          </div>

        </div>

      </div>


    </div>
    <!-- END HEADER -->

    <!-- ==============================
            PAGE LAYOUT (2 COLUMNS)
    =============================== -->
    <div class="profile-layout">

      <!-- ========== LEFT COLUMN ========== -->
      <div class="left-column">

        <!-- =====================================================
              SECTION 1 (EDIT MODE): BANNER + AVATAR + BASIC INFO
        ====================================================== -->
        <div class="card" v-if="isEdit">

          <!-- Gender -->
          <label class="field-label">Gender</label>
          <select class="input-theme" v-model="profile.gender">
            <option>Man</option>
            <option>Woman</option>
            <option>Other</option>
          </select>

          <!-- Domain (KEEPED)
          <label class="field-label">Domain</label>
          <input type="text" class="input-theme" placeholder="mydomain.com" v-model="profile.domain" />
 -->
          <label class="field-label">Email Address</label>
          <input type="email" class="input-theme" placeholder="user@mydomain.com" v-model="profile.email" />

          <label class="field-label">Mobile Number</label>
          <input type="mobile" class="input-theme" placeholder="+**********" v-model="profile.mobile" />

          <!-- Calendar URL (KEEPED) -->
          <label class="field-label">Calendar Url</label>
          <!-- <input type="text" class="input-theme" placeholder="https://..." v-model="profile.calender" /> -->
          <select class="input-theme" v-model="profile.calender">
            <option value="">Not needed</option>
            <option v-for="step in cals" :key="step.booking_page_id"
              :value="base_url1+'appointment/embed/'+step.booking_page_url">{{base_url1}}appointment/embed/{{
              step.booking_page_url }}</option>
          </select>

          <label class="field-label">Instagram</label>
          <input class="input-theme" v-model="profile.profile_page.instagram" />

          <label class="field-label">YouTube</label>
          <input class="input-theme" v-model="profile.profile_page.youtube" />

          <label class="field-label">X (Twitter)</label>
          <input class="input-theme" v-model="profile.profile_page.x" />

          <label class="field-label">LinkedIn</label>
          <input class="input-theme" v-model="profile.profile_page.linkedin" />


          <!-- Location -->
          <label class="field-label">Location</label>
          <!-- <textarea class="textarea-theme" v-model="profile.location"></textarea> -->
          <select class="input-theme" v-model="profile.location">
            <option value="">Select Country</option>

            <option value="Afghanistan">Afghanistan</option>
            <option value="Albania">Albania</option>
            <option value="Algeria">Algeria</option>
            <option value="Andorra">Andorra</option>
            <option value="Angola">Angola</option>
            <option value="Antigua and Barbuda">Antigua and Barbuda</option>
            <option value="Argentina">Argentina</option>
            <option value="Armenia">Armenia</option>
            <option value="Australia">Australia</option>
            <option value="Austria">Austria</option>
            <option value="Azerbaijan">Azerbaijan</option>

            <option value="Bahamas">Bahamas</option>
            <option value="Bahrain">Bahrain</option>
            <option value="Bangladesh">Bangladesh</option>
            <option value="Barbados">Barbados</option>
            <option value="Belarus">Belarus</option>
            <option value="Belgium">Belgium</option>
            <option value="Belize">Belize</option>
            <option value="Benin">Benin</option>
            <option value="Bhutan">Bhutan</option>
            <option value="Bolivia">Bolivia</option>
            <option value="Bosnia and Herzegovina">Bosnia and Herzegovina</option>
            <option value="Botswana">Botswana</option>
            <option value="Brazil">Brazil</option>
            <option value="Brunei">Brunei</option>
            <option value="Bulgaria">Bulgaria</option>
            <option value="Burkina Faso">Burkina Faso</option>
            <option value="Burundi">Burundi</option>

            <option value="Cambodia">Cambodia</option>
            <option value="Cameroon">Cameroon</option>
            <option value="Canada">Canada</option>
            <option value="Cape Verde">Cape Verde</option>
            <option value="Central African Republic">Central African Republic</option>
            <option value="Chad">Chad</option>
            <option value="Chile">Chile</option>
            <option value="China">China</option>
            <option value="Colombia">Colombia</option>
            <option value="Comoros">Comoros</option>
            <option value="Costa Rica">Costa Rica</option>
            <option value="Croatia">Croatia</option>
            <option value="Cuba">Cuba</option>
            <option value="Cyprus">Cyprus</option>
            <option value="Czech Republic">Czech Republic</option>

            <option value="Denmark">Denmark</option>
            <option value="Djibouti">Djibouti</option>
            <option value="Dominica">Dominica</option>
            <option value="Dominican Republic">Dominican Republic</option>

            <option value="Ecuador">Ecuador</option>
            <option value="Egypt">Egypt</option>
            <option value="El Salvador">El Salvador</option>
            <option value="Equatorial Guinea">Equatorial Guinea</option>
            <option value="Eritrea">Eritrea</option>
            <option value="Estonia">Estonia</option>
            <option value="Eswatini">Eswatini</option>
            <option value="Ethiopia">Ethiopia</option>

            <option value="Fiji">Fiji</option>
            <option value="Finland">Finland</option>
            <option value="France">France</option>

            <option value="Gabon">Gabon</option>
            <option value="Gambia">Gambia</option>
            <option value="Georgia">Georgia</option>
            <option value="Germany">Germany</option>
            <option value="Ghana">Ghana</option>
            <option value="Greece">Greece</option>
            <option value="Grenada">Grenada</option>
            <option value="Guatemala">Guatemala</option>
            <option value="Guinea">Guinea</option>
            <option value="Guinea-Bissau">Guinea-Bissau</option>
            <option value="Guyana">Guyana</option>

            <option value="Haiti">Haiti</option>
            <option value="Honduras">Honduras</option>
            <option value="Hungary">Hungary</option>

            <option value="Iceland">Iceland</option>
            <option value="India">India</option>
            <option value="Indonesia">Indonesia</option>
            <option value="Iran">Iran</option>
            <option value="Iraq">Iraq</option>
            <option value="Ireland">Ireland</option>
            <option value="Israel">Israel</option>
            <option value="Italy">Italy</option>

            <option value="Jamaica">Jamaica</option>
            <option value="Japan">Japan</option>
            <option value="Jordan">Jordan</option>

            <option value="Kazakhstan">Kazakhstan</option>
            <option value="Kenya">Kenya</option>
            <option value="Kiribati">Kiribati</option>
            <option value="Kuwait">Kuwait</option>
            <option value="Kyrgyzstan">Kyrgyzstan</option>

            <option value="Laos">Laos</option>
            <option value="Latvia">Latvia</option>
            <option value="Lebanon">Lebanon</option>
            <option value="Lesotho">Lesotho</option>
            <option value="Liberia">Liberia</option>
            <option value="Libya">Libya</option>
            <option value="Liechtenstein">Liechtenstein</option>
            <option value="Lithuania">Lithuania</option>
            <option value="Luxembourg">Luxembourg</option>

            <option value="Madagascar">Madagascar</option>
            <option value="Malawi">Malawi</option>
            <option value="Malaysia">Malaysia</option>
            <option value="Maldives">Maldives</option>
            <option value="Mali">Mali</option>
            <option value="Malta">Malta</option>
            <option value="Marshall Islands">Marshall Islands</option>
            <option value="Mauritania">Mauritania</option>
            <option value="Mauritius">Mauritius</option>
            <option value="Mexico">Mexico</option>
            <option value="Micronesia">Micronesia</option>
            <option value="Moldova">Moldova</option>
            <option value="Monaco">Monaco</option>
            <option value="Mongolia">Mongolia</option>
            <option value="Montenegro">Montenegro</option>
            <option value="Morocco">Morocco</option>
            <option value="Mozambique">Mozambique</option>
            <option value="Myanmar">Myanmar</option>

            <option value="Namibia">Namibia</option>
            <option value="Nauru">Nauru</option>
            <option value="Nepal">Nepal</option>
            <option value="Netherlands">Netherlands</option>
            <option value="New Zealand">New Zealand</option>
            <option value="Nicaragua">Nicaragua</option>
            <option value="Niger">Niger</option>
            <option value="Nigeria">Nigeria</option>
            <option value="North Korea">North Korea</option>
            <option value="North Macedonia">North Macedonia</option>
            <option value="Norway">Norway</option>

            <option value="Oman">Oman</option>

            <option value="Pakistan">Pakistan</option>
            <option value="Palau">Palau</option>
            <option value="Panama">Panama</option>
            <option value="Papua New Guinea">Papua New Guinea</option>
            <option value="Paraguay">Paraguay</option>
            <option value="Peru">Peru</option>
            <option value="Philippines">Philippines</option>
            <option value="Poland">Poland</option>
            <option value="Portugal">Portugal</option>

            <option value="Qatar">Qatar</option>

            <option value="Romania">Romania</option>
            <option value="Russia">Russia</option>
            <option value="Rwanda">Rwanda</option>

            <option value="Saint Kitts and Nevis">Saint Kitts and Nevis</option>
            <option value="Saint Lucia">Saint Lucia</option>
            <option value="Saint Vincent and the Grenadines">Saint Vincent and the Grenadines</option>
            <option value="Samoa">Samoa</option>
            <option value="San Marino">San Marino</option>
            <option value="Sao Tome and Principe">Sao Tome and Principe</option>
            <option value="Saudi Arabia">Saudi Arabia</option>
            <option value="Senegal">Senegal</option>
            <option value="Serbia">Serbia</option>
            <option value="Seychelles">Seychelles</option>
            <option value="Sierra Leone">Sierra Leone</option>
            <option value="Singapore">Singapore</option>
            <option value="Slovakia">Slovakia</option>
            <option value="Slovenia">Slovenia</option>
            <option value="Solomon Islands">Solomon Islands</option>
            <option value="Somalia">Somalia</option>
            <option value="South Africa">South Africa</option>
            <option value="South Korea">South Korea</option>
            <option value="South Sudan">South Sudan</option>
            <option value="Spain">Spain</option>
            <option value="Sri Lanka">Sri Lanka</option>
            <option value="Sudan">Sudan</option>
            <option value="Suriname">Suriname</option>
            <option value="Sweden">Sweden</option>
            <option value="Switzerland">Switzerland</option>
            <option value="Syria">Syria</option>

            <option value="Taiwan">Taiwan</option>
            <option value="Tajikistan">Tajikistan</option>
            <option value="Tanzania">Tanzania</option>
            <option value="Thailand">Thailand</option>
            <option value="Timor-Leste">Timor-Leste</option>
            <option value="Togo">Togo</option>
            <option value="Tonga">Tonga</option>
            <option value="Trinidad and Tobago">Trinidad and Tobago</option>
            <option value="Tunisia">Tunisia</option>
            <option value="Turkey">Turkey</option>
            <option value="Turkmenistan">Turkmenistan</option>

            <option value="Uganda">Uganda</option>
            <option value="Ukraine">Ukraine</option>
            <option value="United Arab Emirates">United Arab Emirates</option>
            <option value="United Kingdom">United Kingdom</option>
            <option value="United States">United States</option>
            <option value="Uruguay">Uruguay</option>
            <option value="Uzbekistan">Uzbekistan</option>

            <option value="Vanuatu">Vanuatu</option>
            <option value="Vatican City">Vatican City</option>
            <option value="Venezuela">Venezuela</option>
            <option value="Vietnam">Vietnam</option>

            <option value="Yemen">Yemen</option>
            <option value="Zambia">Zambia</option>
            <option value="Zimbabwe">Zimbabwe</option>

          </select>

          <!-- Description -->
          <label class="field-label">Description</label>
          <textarea class="textarea-theme" v-model="profile.description"></textarea>

          <!-- Languages -->
          <label class="field-label">Languages spoken fluently</label>
          <div class="tags-input">
            <div class="tag" v-for="(lang,i) in profile.languages" :key="i">
              {{ lang }}
              <i class="bx bx-x" @click="removeLanguage(i)"></i>
            </div>
            <input v-model="languageInput" placeholder="Type language..." @keyup.enter="addLanguage" />
          </div>
        </div>

        <!-- =====================================================
              SECTION 2 (EDIT MODE): CAMERA + INDUSTRIES + EQUIPMENTS
        ====================================================== -->
        <div class="card" v-if="isEdit">

          <!-- Camera -->
          <label class="field-label">Camera type</label>
          <div class="chip-row">
            <span class="chip" :class="{active: profile.camera === 'Smartphone'}" @click="profile.camera='Smartphone'">
              Smartphone
            </span>
            <span class="chip" :class="{active: profile.camera === 'Professional camera'}"
              @click="profile.camera='Professional camera'">
              Professional camera
            </span>
          </div>

          <!-- Industries -->
          <label class="field-label">Industries (with custom tag)</label>
          <div class="chip-grid">
            <span class="chip" v-for="(ind,i) in industries" :key="i"
              :class="{active: profile.industries.includes(ind)}" @click="toggleIndustry(ind)">
              {{ ind }}
            </span>
          </div>

          <input class="input-theme" placeholder="Add custom industry..." @keyup.enter="addCustomIndustry($event)" />

          <!-- Equipment -->
          <label class="field-label">Equipment</label>
          <div class="chip-grid">
            <span class="chip" v-for="(eq,i) in equipments" :key="i" :class="{active: profile.equipment.includes(eq)}"
              @click="toggleEquipment(eq)">
              {{ eq }}
            </span>
          </div>

          <input class="input-theme" placeholder="Add custom equipment..." @keyup.enter="addCustomEquipment($event)" />

          <!-- Filming -->
          <!-- <label class="field-label">Filming</label>
          <div class="chip-grid">
            <span class="chip" v-for="(f,i) in filmingTypes" :key="i" :class="{active: profile.filming.includes(f)}"
              @click="toggleFilming(f)">
              {{ f }}
            </span>
          </div> -->

          <!-- Pets -->
          <!-- <label class="field-label">Pets</label>
          <div class="chip-row">
            <span class="chip" :class="{active: profile.pets.includes('Dog')}" @click="togglePet('Dog')">Dog</span>
            <span class="chip" :class="{active: profile.pets.includes('Cat')}" @click="togglePet('Cat')">Cat</span>
          </div> -->

        </div>

        <!-- =====================================================
              SECTION 3: BRAND LOGOS
        ====================================================== -->
        <div class="card" v-if="isEdit">
          <h3>Brands that have trusted me</h3>

          <label class="upload-btn">
            <i class="bx bx-upload"></i> Upload Logos
            <input type="file" hidden multiple @change="uploadBrandLogos" />
          </label>

          <div class="brand-logo-grid">
            <div class="brand-item" v-for="(b,i) in profile.brandLogos" :key="i">
              <img :src="base_url + b" class="brand-logo-img" />
              <div class="brand-delete" @click="removeBrandLogo(i)">
                <i class="bx bx-trash"></i>
              </div>
            </div>

          </div>
        </div>

        <!-- =====================================================
              SECTION 4: UGC VIDEOS
        ====================================================== -->
        <div class="card">
          <div class="ugc-header">
            <h3>My UGC</h3>

            <label v-if="isEdit" class="ugc-upload-btn">
              <i class="bx bx-upload"></i> Upload
              <input type="file" hidden multiple @change="handleUGCUpload" />
            </label>
          </div>

          <div class="ugc-grid">
            <div class="media-card" v-for="(m,i) in profile.ugc" :key="i">
              <img v-if="m.type==='image'" :src="base_url+m.url" @click="openViewer(m.url, 'image')"  />
              
              <div 
                v-if="m.type === 'video'"
                class="ugc-preview"
                @click="openViewer(m.url, 'video')"
              >

                <video
                  class="ugc-player"
                  :src="base_url + m.url"
                  preload="metadata" 
                  muted
                  playsinline
                ></video>
                <a href="javascript:void(0)"><div class="play-btn">▶</div></a>
              </div>

              <div v-if="isEdit" class="delete-btn" @click="removeUGC(i)">
                <i class="bx bx-trash"></i>
              </div>
            </div>
          </div>

          <button v-if="!isEdit" class="show-more-btn">Show more</button>
        </div>



        <!-- FAQ SECTION (same) -->
        <div class="card">

          <div class="faq-header">
            <h3>FAQ</h3>

            <button v-if="isEdit" class="btn-primary" @click="openFAQModal()">
              + Add Question
            </button>
          </div>

          <div v-for="(f,i) in dummyFAQs" :key="i" class="faq-item improved">

            <div class="faq-question" @click="f.open=!f.open">
              <h4>{{ f.q }}</h4>
              <i class="bx bx-chevron-down" :class="{open:f.open}"></i>
            </div>

            <div v-if="f.open" class="faq-answer">

              <p>{{ f.a }}</p>

              <div v-if="isEdit" class="faq-actions-bar">

                <button class="faq-btn edit" @click="editFAQ(i)">
                  Edit
                </button>

                <button class="faq-btn delete" @click="removeFAQ(i)">
                  Delete
                </button>

              </div>

            </div>

          </div>

        </div>

         <div class="card" v-if="profile.calender">
          <div class="ugc-header">
            <h3>Book Appointment</h3>
          </div>

          <div v-if="!profile.calender" class="calendar-placeholder">
            <i class="bx bx-calendar-x"></i>
            <p>No appointment link added yet</p>
          </div>

          <iframe v-else :src="profile.calender" class="booking-iframe" frameborder="0" loading="lazy"
            style="width: 100%; height: 52.8vh; border-color: #fff!important;"></iframe>
        

        </div>

        <!-- MAP -->
        <div class="card" v-if="!isEdit">
          <h3>{{ profile.location }}</h3>
          <iframe class="map-iframe" :src="googleMapUrl"></iframe>
        </div>

        <!-- REVIEWS (unchanged) -->
        <!-- <div class="card">
          <h3>Reviews</h3>

          <div v-if="!isEdit" class="review-stats">
            <div class="big-rating">
              <i class="bx bxs-star"></i> <span>{{ profile.rating }}</span>
            </div>

            <div class="rating-bars">
              <div class="rating-bar-row" v-for="(bar,i) in ratingBars" :key="i">
                <span>{{ 5 - i }}</span>
                <div class="bar-container">
                  <div class="bar-fill" :style="{width: bar + '%'}"></div>
                </div>
              </div>
            </div>
          </div>

          <div class="review-card" v-for="(r,i) in profile.reviews" :key="i">
            <div class="review-header">
              <h4>{{ r.name }}</h4>
              <div class="rating">
                <i class="bx bxs-star"></i> {{ r.rating }}
              </div>
            </div>
            <p>{{ r.text }}</p>
            <span class="review-date">{{ r.date }}</span>
          </div>

          <button v-if="!isEdit" class="show-more-btn">Show more</button>
        </div> -->

        <!-- COMMENT FORM -->
        <!-- <div v-if="!isEdit" class="card comment-card">
          <h3>Leave a review</h3>

          <div class="comment-form-row">
            <label class="field-label">Your Name</label>
            <input class="input-theme" v-model="newComment.name" />
          </div>

          <div class="comment-form-row">
            <label class="field-label">Your Rating</label>
            <select class="input-theme" v-model="newComment.rating">
              <option disabled value="">Select rating</option>
              <option value="5">⭐⭐⭐⭐⭐</option>
              <option value="4">⭐⭐⭐⭐</option>
              <option value="3">⭐⭐⭐</option>
              <option value="2">⭐⭐</option>
              <option value="1">⭐</option>
            </select>
          </div>

          <div class="comment-form-row">
            <label class="field-label">Your Comment</label>
            <textarea class="textarea-theme" v-model="newComment.text"></textarea>
          </div>

          <button class="btn-primary full-btn" @click="submitComment">
            <i class="bx bx-send"></i> Submit Comment
          </button>
        </div> -->

        <!-- USERNAME FINAL SAVE -->
        <div class="card" v-if="isEdit">
          <h3>Your username</h3>
          <input type="text" class="input-theme" v-model="profile.username" />
          <button class="btn-primary save-btn" @click="saveProfile">Save</button>
        </div>

      </div>
      <!-- END LEFT -->

      <!-- ========== RIGHT COLUMN ========== -->
      <div class="right-column">

        <!-- Visibility Warning -->
        <!-- <div class="sidebar-card alert-card" v-if="isEdit">
          <div class="alert-title">
            <i class="bx bx-error-circle"></i> Your profile is not visible to brands
          </div>
          <p class="alert-subtitle">Complete the following steps:</p>
          <ul class="alert-list">
            <li><i class="bx bx-check"></i> Complete your Stripe account</li>
            <li><i class="bx bx-check"></i> Add billing information</li>
            <li><i class="bx bx-check"></i> Increase your score to 80%</li>
          </ul>
        </div> -->

        <div class="sidebar-card" v-if="
          profile.profile_page.instagram ||
          profile.profile_page.youtube ||
          profile.profile_page.x ||
          profile.profile_page.linkedin
        ">
          <h3>Social Profiles</h3>

          <div class="social-grid">

            <a v-if="profile.profile_page.instagram" :href="profile.profile_page.instagram" target="_blank"
              class="social-btn instagram">
              <i class="bx bxl-instagram"></i>
            </a>

            <a v-if="profile.profile_page.youtube" :href="profile.profile_page.youtube" target="_blank"
              class="social-btn youtube">
              <i class="bx bxl-youtube"></i>
            </a>

            <a v-if="profile.profile_page.x" :href="profile.profile_page.x" target="_blank" class="social-btn x">
              <i class="bx bxl-twitter"></i>
            </a>

            <a v-if="profile.profile_page.linkedin" :href="profile.profile_page.linkedin" target="_blank"
              class="social-btn linkedin">
              <i class="bx bxl-linkedin"></i>
            </a>

          </div>
        </div>

        <!-- Pricing -->
        <div v-if="isEdit" class="sidebar-card">
          <h3>Pricing Packages</h3>
          <button class="btn-primary full-btn" @click="openPlanModal()">+ Add Package</button>
        </div>

        <div class="sidebar-card pricing-card" v-for="pkg in pricingPackages" :key="pkg.website_plan_id">

          <div class="pricing-header">
            <h3>{{ pkg.website_plan_title }}</h3>
            <div class="price">{{ pkg.website_plan_curr }}{{ pkg.website_plan_price }}</div>
          </div>

          <p>{{ pkg.website_plan_desc }}</p>

          <ul class="feature-list">
            <li v-for="f in pkg.features" :key="f">
              <i class="bx bx-check"></i> {{ f }}
            </li>
          </ul>

          <div v-if="isEdit" style="margin-top:10px; display:flex; gap:10px;">
            <button class="btn-primary" @click="openPlanModal(pkg)">
              <i class="bx bx-edit"></i> Edit
            </button>
            <button class="btn-secondary red" @click="deletePlan(pkg.website_plan_id)">
              <i class="bx bx-trash"></i> Delete
            </button>

            <label class="toggle-label">
              <input type="checkbox" :checked="pkg.website_plan_status==='active'" @change="togglePlanStatus(pkg)" />
              Active
            </label>
          </div>

          <button v-if="!isEdit" class="btn-primary full-btn" @click="startCheckout(pkg)">Order Now</button>
        </div>

        <!-- SCORE -->
        <!-- <div class="sidebar-card score-card">
          <h3>Your July toss score</h3>

          <div class="progress-bar">
            <div class="progress-fill" :style="{ width: profile.score + '%' }"></div>
          </div>

          <ul class="score-list">
            <li v-for="(step,i) in profile.scoreBreakdown" :key="i">
              {{ step.label }}
              <span class="right">{{ step.points }}</span>
            </li>
          </ul>
        </div> -->

        <div class="sidebar-card">
          <button class="btn-primary full-btn" @click="openContactModal()">
            <i class="bx bx-message-rounded"></i> Contact
          </button>
        </div>

        <!-- <div class="sidebar-card">
          <h3>Quick Stats</h3>
          <ul class="stats-list">
            <li><b>Total Reviews:</b> {{ profile.reviews.length }}</li>
            <li><b>UGC Items:</b> {{ profile.ugc.length }}</li>
            <li><b>Languages:</b> {{ profile.languages.length }}</li>
          </ul>
        </div> -->



      </div>
      <!-- END RIGHT COLUMN -->

    </div>
    <!-- END LAYOUT -->
    <!-- FAQ MODAL -->
    <div v-if="showFAQModal" class="modal-overlay">
      <div class="modal-box">

        <h3>{{ faqForm.index===null ? "Add FAQ" : "Edit FAQ" }}</h3>

        <label class="field-label">Question</label>
        <input class="input-theme" v-model="faqForm.q" />

        <label class="field-label">Answer</label>
        <textarea class="textarea-theme" v-model="faqForm.a"></textarea>

        <div class="modal-actions">
          <button class="btn-sceondary" @click="showFAQModal=false">
            Cancel
          </button>

          <button class="btn-primary" @click="saveFAQFromModal">
            Save
          </button>
        </div>

      </div>
    </div>


    <!-- PLAN MODAL -->
    <div v-if="showPlanModal" class="modal-overlay">
      <div class="modal-box">

        <h3>{{ planForm.website_plan_id ? "Edit Package" : "Add New Package" }}</h3>

        <label class="field-label">Name of the plan</label>
        <input class="input-theme" v-model="planForm.website_plan_title" />


        <!-- <label class="field-label">No of Items</label>
        <input class="input-theme" v-model="planForm.website_plan_duration" /> -->

        <label class="field-label">Description</label>
        <textarea class="textarea-theme" v-model="planForm.website_plan_desc"></textarea>

        <label class="field-label">Features (One per line)</label>
        <textarea class="textarea-theme" v-model="planForm.website_plan_features"></textarea>

        <label class="field-label">Price</label>
        <input class="input-theme" v-model="planForm.website_plan_price" />

        <label class="field-label">Price</label>
        <select class="input-theme" v-model="planForm.website_plan_curr">
          <option value="$">$</option>
          <option value="INR">INR</option>
        </select>

        <div class="modal-actions">
          <button class="btn-secondary" @click="showPlanModal=false">Cancel</button>
          <button class="btn-primary" @click="savePlan">Save Package</button>
        </div>

      </div>
    </div>

    <!-- CHAT BUTTON -->
    <div class="chat-button" @click="toggleChatbox">
      <i class="bx bx-message-rounded-dots"></i>
    </div>

    <!-- CHATBOX -->
    <div v-if="showChatbox" class="chatbox-container">
      <div class="chatbox-header">
        <span>Chat with AI</span>
        <i class="bx bx-x" @click="toggleChatbox"></i>
      </div>

      <div class="chatbox-messages" ref="chatScroll">
        <div v-for="msg in chatMessages" :key="msg.id">
          <div class="msg ai" v-if="msg.sender==='ai'" v-html="formatMessage(msg.text)"></div>

          <div class="msg user" v-else>{{ msg.text }}</div>
        </div>
      </div>

      <div class="chatbox-input">
        <input type="text" v-model="chatInput" @keyup.enter="sendChat" placeholder="Type your message..." />
        <button @click="sendChat">
          <i class="bx bx-send"></i>
        </button>
      </div>
    </div>

    <ConfirmDialog :show="showConfirm" :title="confirmTitle" :message="confirmMessage" @cancel="showConfirm = false"
      @confirmAction="handleConfirm" />

    <!-- CONTACT MODAL -->
    <div v-if="showContactModal" class="modal-overlay">
      <div class="modal-box contact-modal">

        <!-- Header -->
        <h3 class="contact-title">Let’s Connect 🤝</h3>
        <p class="contact-subtitle">
          Have a question or project in mind?
        </p>

        <!-- My Contact Details -->
        <div class="my-contact-card">
          <div class="contact-row">
            <i class="bx bx-phone"></i>
            <span>{{ profile.mobile }}</span>
          </div>
          <div class="contact-row">
            <i class="bx bx-envelope"></i>
            <span>{{ profile.email }}</span>
          </div>
        </div>

        <!-- Form -->
        <label class="field-label">Your Name</label>
        <input class="input-theme" v-model="contactForm.name" />

        <label class="field-label">Your Email</label>
        <input class="input-theme" v-model="contactForm.email" />

        <label class="field-label">Phone (optional)</label>
        <input class="input-theme" v-model="contactForm.phone" />

        <label class="field-label">Your Message</label>
        <textarea class="textarea-theme" placeholder="Tell me a little about your requirement..."
          v-model="contactForm.message"></textarea>

        <!-- Actions -->
        <div class="modal-actions">
          <button class="btn-secondary" @click="showContactModal=false">
            Cancel
          </button>
          <button class="btn-primary" @click="submitContact">
            <i class="bx bx-send"></i> Send Message
          </button>
        </div>

      </div>
    </div>
    <div v-if="viewer.visible" class="modal-overlay" @click.self="closeViewer">

      <div class="modal-box media-modal">

        <span class="mv-close" @click="closeViewer">&times;</span>

        <!-- IMAGE -->
        <img 
          v-if="viewer.type === 'image'" 
          :src="viewer.src" 
          class="mv-content"
        />

        <!-- VIDEO -->
        <video 
          v-if="viewer.type === 'video'" 
          :src="viewer.src" 
          class="mv-content"
          controls
          autoplay
        ></video>

      </div>

    </div>


  </div>
</template>

<script>
  import Plyr from "plyr";
  import { useToast } from "vue-toastification";
  import ConfirmDialog from "@/comps/ConfirmDialog.vue";
  import { getBookPages } from "@/apis/bookpageapis";
  import {
    getWebsitePlans,
    createWebsitePlan,
    deleteWebsitePlan
  } from "@/apis/webplanapis";

  import {
    addOrUpdateProfile,
    getProfileByUserId,

    addOrUpdateMedia,
    deleteMedia,
    getMediaList,

    addReview,
    getReviewList,
    publishWeb,
    submitLead
  } from "@/apis/profileapi";

  import {
    apiBaseUrl,
    mainBaseUrl
  } from "@/apis/appconst";
  import {
    uploadFile
  } from "@/apis/invoiceapis";
  import {
    getLastConversation,
    getMessages,
    sendUserMessage,
    getAIMessage
  } from "@/apis/chatbotapis";

  export default {
    name: "ProfilePage",
    components: {
      ConfirmDialog
    },
    data() {
      return {
        viewer: {
          visible: false,
          src: '',
          type: ''
        },
        showContactModal: false,
        iframeh:"1px",
        contactForm: {
          name: "",
          email: "",
          phone: "",
          message: ""
        },
        profile_page: {
          instagram: "",
          youtube: "",
          x: "",
          linkedin: ""
        },

        cals: [],
        showConfirm: false,
        isEditorMode: false,
        confirmTitle: "",
        confirmMessage: "",
        user_id: Date.now().toString(),
        showChatbox: false,
        chatInput: "",
        chatMessages: [],
        chatConvId: "",
        showFAQModal: false,
        pricingPackages: [],

        planForm: {
          website_plan_id: "",
          website_plan_title: "",
          website_plan_price: "",
          website_plan_duration: "",
          website_plan_desc: "",
          website_plan_type: "",
          website_plan_curr: "$",
          website_plan_features: "",
          website_plan_parent: "",
          website_plan_status: "active",
          website_plan_user: "",
          website_plan_page: ""
        },

        showPlanModal: false,

        faqForm: {
          faq_id: "",
          question: "",
          answer: "",
          published: false
        },
        toast: useToast(),
        base_url: "",
        base_url1: "",
        isEdit: false,
        isLoading: false,
        showFull: false,
        languageInput: "",

        /* ==============================
          NEW COMMENT FORM (Review Add)
        =============================== */
        newComment: {
          name: "",
          rating: "",
          text: ""
        },
        dummyFAQs: [
          {
            q: "What services do you offer?",
            a: "I offer professional UGC content creation, product reviews, lifestyle videos, and brand storytelling.",
            open: false
          },
          {
            q: "How long is the delivery time?",
            a: "Delivery time typically ranges from 3–7 days depending on project scope.",
            open: false
          },
          {
            q: "Do you provide revisions?",
            a: "Yes, I offer 1–2 free revisions depending on the package selected.",
            open: false
          },
          {
            q: "Can brands send products to you?",
            a: "Yes, brands can ship products directly to my location after booking is confirmed.",
            open: false
          }
        ],
        faqs: [],
        /* ==============================
          CLEAN PROFILE OBJECT (DB SAFE)
          Matches profile_tbl exactly
        =============================== */
        profile: {
          profile_id: "",
          profile_user: "",
          profile_page: "",

          banner: "/images/ban_plance.png",
          avatar: "/images/uplace.jpg",
          name: "",
          username: "",
          calender: "",
          email: "",
          mobile: "",
          domain: "",
          verified: false,

          rating: 0,
          reviewCount: 0,
          availability: "",
          status: "",

          /* DETAILS */
          location: "",
          gender: "",
          description: "",
          shortDescLimit: 110,
          camera: "",
          responseTime: "",
          orderCount: 0,

          /* ARRAY FIELDS (stored as JSON) */
          languages: [],
          industries: [],
          equipment: [],
          filming: [],
          pets: [],

          /* MEDIA DATA */
          brandLogos: [],     // future usage
          ugc: [],            // loaded from media_tbl

          /* FAQ (will be used later) */
          faq: [],


          /* REVIEWS DATA (review_tbl) */
          reviews: [],


          /* SCORE */
          score: 0,
          scoreBreakdown: [],
          paypal: false,
          razorpay: false,
          stripe: false,
        },


        /* ==========================================
          SELECTABLE OPTIONS
        =========================================== */
        industries: [
          "App & Tech",
          "Apparel",
          "Consumer Goods",
          "Cosmetics",
          "Food & Beverages",
          "Health, Wellness, Fitness",
          "Kids",
          "Pets",
          "Travel & Places"
        ],

        equipments: [
          "House",
          "Apartment",
          "Garden",
          "Car",
          "Motorbike",
          "Bike"
        ],

        filmingTypes: [
          "Couple",
          "Baby",
          "Child",
          "Parent",
          "Family",
          "Friends"
        ]
      };
    },
    computed: {
      shortDescription() {
        if (this.showFull) return "";
        return this.profile.description;
      },
      ratingBars() {
        // Simulated values (5 → 1)
        return [90, 6, 3, 1, 0];
      },
      googleMapUrl() {
        if (!this.profile.location) return "";
        return `https://www.google.com/maps?q=${encodeURIComponent(this.profile.location)}&output=embed`;
      }
    },

    methods: {
      
      openViewer(src, type) {

        const finalUrl = this.base_url + src

        console.log("FINAL URL =", finalUrl)

        this.viewer.src = finalUrl
        this.viewer.type = type
        this.viewer.visible = true
      },

      closeViewer() {
        this.viewer.visible = false
        this.viewer.src = ''
        this.viewer.type = ''
      },
      initUGCPlayers(){
        this.$nextTick(() => {

          const players = document.querySelectorAll(".ugc-player");

          players.forEach(el => {

            if (el._plyr) return;

            el._plyr = new Plyr(el, {
              clickToPlay: true,
              hideControls: true,
              controls: [
                "play",
                "progress",
                "current-time",
                "mute",
                "volume",
                "fullscreen"
              ]
            });

          });

        });
      }


      ,
     loadGAScript(measurementId) {

        // Prevent duplicate load
        if (document.getElementById('ga-script')) return;

        // Load external gtag file
        const script1 = document.createElement('script');
        script1.id = 'ga-script';
        script1.async = true;
        script1.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
        document.head.appendChild(script1);

        // Init config
        const script2 = document.createElement('script');
        script2.innerHTML = `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${measurementId}');
        `;
        document.head.appendChild(script2);
      },
      openFAQModal() {
        this.faqForm = {
          index: null,
          q: "",
          a: ""
        };
        this.showFAQModal = true;
      },

      editFAQ(i) {
        const f = this.dummyFAQs[i];

        this.faqForm = {
          index: i,
          q: f.q,
          a: f.a
        };

        this.showFAQModal = true;
      },

      saveFAQFromModal() {
        if (!this.faqForm.q || !this.faqForm.a) {
          this.toast.error("Fill question & answer");
          return;
        }

        if (this.faqForm.index === null) {
          // ADD
          this.dummyFAQs.push({
            q: this.faqForm.q,
            a: this.faqForm.a,
            open: false
          });
        } else {
          // UPDATE
          this.dummyFAQs[this.faqForm.index].q = this.faqForm.q;
          this.dummyFAQs[this.faqForm.index].a = this.faqForm.a;
        }

        this.showFAQModal = false;
      },

      removeFAQ(i) {
        this.dummyFAQs.splice(i, 1);
      }
      ,
      formatMessage(text) {
        if (!text) return "";

        return text
          // Convert line breaks
          .replace(/\n/g, "<br>")
          .replace(/<br><br>/g, "</p><p>")
          // Bold headings
          .replace(/Package Title:/g, "<strong>Package:</strong>")
          .replace(/Price:/g, "<strong>Price:</strong>")
          .replace(/Description:/g, "<strong>Description:</strong>")
          .replace(/Features:/g, "<strong>Features:</strong>")
          // Numbered list spacing
          .replace(/(\d+)\./g, "<br><strong>$1.</strong>")
          // Bullet points
          .replace(/- (.*?)(<br>|$)/g, "• $1<br>")
          // Wrap whole thing
          .replace(/^/, "<p>")
          .concat("</p>");
      }
      ,
      openContactModal() {
        this.showContactModal = true;
      },

      async submitContact() {
        try {
          if (!this.contactForm.name || !this.contactForm.email || !this.contactForm.message) {
            this.toast.error("Please fill required fields");
            return;
          }
          this.isLoading = true;

          const encoded = btoa(JSON.stringify({
            lead_name: this.contactForm.name,
            lead_email: this.contactForm.email,
            lead_source: this.contactForm.phone,
            lead_status: "Pending",
            lead_desc: `${this.contactForm.message}`,
            lead_website: this.profile.profile_id,
            lead_user: this.profile.profile_user
          }));

          const res = await submitLead(encoded);

          this.isLoading = false;

          if (res?.status) {

            this.toast.success(res.msg || "Submitted successfully!");

            // clear form
            this.contactForm = {
              name: "",
              email: "",
              phone: "",
              message: ""
            };

            this.showContactModal = false;

          } else {
            this.toast.error(res.msg || "Something went wrong");
          }

        } catch (err) {

          this.isLoading = false;

          console.error("Lead Error:", err);

          this.toast.error("Network error");

        }

      },


      addCustomEquipment(e) {
        const val = e.target.value.trim();
        if (!val) return;

        if (!this.equipments.includes(val)) {
          this.equipments.push(val);
        }

        if (!this.profile.equipment.includes(val)) {
          this.profile.equipment.push(val);
        }

        e.target.value = "";
      }
      ,
      addCustomIndustry(e) {
        const val = e.target.value.trim();
        if (!val) return;

        // add into master list if not exists
        if (!this.industries.includes(val)) {
          this.industries.push(val);
        }

        // add into selected profile industries
        if (!this.profile.industries.includes(val)) {
          this.profile.industries.push(val);
        }

        e.target.value = "";
      }
      ,
      syncCustomChips(masterList, selectedList) {
        if (!Array.isArray(selectedList)) return;

        selectedList.forEach(item => {
          if (!masterList.includes(item)) {
            masterList.push(item);
          }
        });
      }
      ,
      async fetchPages() {
        // const toast = useToast();
        try {

          const res = await getBookPages(
            this.profile.profile_user,
            "none",
            "",
            "",
            ""
          );
          if (res.status && res.records?.length) {
            this.cals = res.records;
          } else {
            this.cals = [];
            // toast.success(res.success || "No pages found");
          }
        } catch (error) {
          console.error("fetchPages error:", error);
          // toast.error("Failed to load pages");
        }
      },
      removeBrandLogo(i) {
        this.profile.brandLogos.splice(i, 1);
      }
      ,
      chkAt() {
        const domain = this.profile.domain.trim();

        if (!domain) return "@";

        const parts = domain.split(".");

        if (parts.length === 2) {
          return "@";
        }
        return parts.slice(0, parts.length - 2).join(".");
      },
      confirmCallback() { },
      async openConfirm(title, message, onConfirm) {
        this.confirmTitle = title;
        this.confirmMessage = message;
        this.confirmCallback = onConfirm;
        this.showConfirm = true;
      },
      async handleConfirm() {
        this.showConfirm = false;

        if (typeof this.confirmCallback === "function") {
          await this.confirmCallback();
        }

        this.confirmCallback = null;
      }
      ,
      copyLink() {
        const str = this.base_url1 + "new_single_web/" + this.profile.username;

        navigator.clipboard.writeText(str)
          .then(() => {
            this.toast.success("Link copied!");
          })
          .catch(() => {
            // Fallback for older browsers
            const input = document.createElement("input");
            input.value = str;
            document.body.appendChild(input);
            input.select();
            document.execCommand("copy");
            document.body.removeChild(input);
            this.toast.success("Link copied!");
          });
      }
      ,
      exportAndPublishHTML() {
        this.openConfirm(
          "Publish Website?",
          `Are you sure you want to publish?`,
          async () => {
            try {

              // 3️⃣ Upload to server
              this.isLoading = true;
              const res = await publishWeb(this.profile.profile_id);
              this.isLoading = false;

              // 4️⃣ Handle success
              if (res.status) {
                this.toast.success("Website Published Successfully!");
                window.location.href = mainBaseUrl+"new_single_web/" + this.profile.username;

              } else {
                this.toast.error(res.success || "Publishing failed");
              }

            } catch (err) {
              console.error("Publish HTML Error:", err);
              this.toast.error("Network or Server Error");
            }
          }
        );
      }
      ,
      async startCheckout(pkg) {
        try {
          const amount = parseFloat(pkg.website_plan_price);
          // const user_id = this.user_id;

          // 1️⃣ Open popup before API call (avoid popup-block)
          const popup = window.open("", "checkoutWindow", "width=480,height=600");

          if (!popup) {
            this.toast.error("Please allow popup in your browser.");
            return;
          }


          let active = [];
          if (this.profile.paypal === "active") active.push("paypal");
          if (this.profile.razorpay === "active") active.push("razorpay");
          if (this.profile.stripe === "active") active.push("stripe");

          if (active.length === 0) {
            popup.close();
            this.toast.error("No payment gateway is active.");
            return;
          }

          // 3️⃣ If only 1 gateway → auto start
          if (active.length === 1) {
            this.openGateway(active[0], popup, pkg, amount);
            return;
          }

          // 4️⃣ Otherwise show modal inside popup
          popup.document.write(`
            <html>
              <head>
                <title>Select Gateway</title>
                <style>
                  body { font-family: sans-serif; padding: 20px; }
                  button { padding: 10px 20px; margin: 10px; font-size: 16px; }
                </style>
              </head>
              <body>
                <h2>Select Payment Method</h2>
                ${active
              .map(
                (g) =>
                  `<button onclick="window.opener.postMessage('${g}','*')">${g.toUpperCase()}</button>`
              )
              .join("")}
              </body>
            </html>
          `);

          // Listen for gateway selection
          window.addEventListener(
            "message",
            (e) => {
              if (active.includes(e.data)) {
                this.openGateway(e.data, popup, pkg, amount);
              }
            },
            { once: true }
          );
        } catch (err) {
          console.error("Checkout error:", err);
        }
      },

      openGateway(gateway, popup, pkg, amount) {
        const website_id = this.profile.profile_id;
        const user_id = this.user_id;

        const checkoutUrl =
          apiBaseUrl +
          `payment/${gateway}_init?amount=${amount}&website_id=${website_id}&user_id=${user_id}&plan_id=${pkg.website_plan_id}`;

        popup.location.href = checkoutUrl;

        // Listen for payment success/failure
        window.addEventListener("message", (e) => {
          if (e.data === "payment_success") {
            popup.close();

            this.toast.success("Payment successful!");
          } else if (e.data === "payment_failed") {
            popup.close();

            this.toast.error("Payment failed.");
          }
        });
      }
      ,
      toggleChatbox() {
        this.showChatbox = !this.showChatbox;
        if (this.showChatbox) {
          this.initChat();
        }
      },

      async initChat() {
        const website_id = this.profile.profile_id;


        // 1️⃣ Get/Create Conversation
        const conv = await getLastConversation(this.user_id, website_id);
        if (conv.status && conv.conv_dt) {
          this.chatConvId = conv.conv_dt.conv_id;
        }

        // 2️⃣ Load Previous Messages
        const msgs = await getMessages(this.chatConvId, this.user_id, 0);
        if (msgs.status) {
          this.chatMessages = msgs.records.map(m => ({
            id: m.msg_id,
            sender: m.msg_user1 === "Bot" ? "user" : "ai",
            text: m.msg_txt
          }));
        }

        this.$nextTick(() => this.scrollChat());
      },

      scrollChat() {
        const box = this.$refs.chatScroll;
        if (box) box.scrollTop = box.scrollHeight;
      },

      async sendChat() {
        if (!this.chatInput.trim()) return;

        const userText = this.chatInput;
        this.chatInput = "";

        // Add to UI immediately
        this.chatMessages.push({
          id: Date.now(),
          sender: "user",
          text: userText
        });
        this.scrollChat();

        // 3️⃣ Send User Message
        const res = await sendUserMessage(this.chatConvId, this.user_id, userText);

        if (!res.status || !res.msg_dt) return;

        const msgId = res.msg_dt.msg_id;

        // 4️⃣ Fetch AI reply
        const ai = await getAIMessage(msgId);

        if (ai.status) {
          this.chatMessages.push({
            id: ai.msg_dt.msg_id,
            sender: "ai",
            text: ai.msg_dt.msg_txt
          });
          this.scrollChat();
        }
      },
      openPlanModal(plan = null) {
        if (plan) {
          // Editing
          this.planForm = {
            website_plan_id: plan.website_plan_id,
            website_plan_title: plan.website_plan_title,
            website_plan_price: plan.website_plan_price,
            website_plan_duration: plan.website_plan_duration,
            website_plan_desc: plan.website_plan_desc,
            website_plan_type: plan.website_plan_type,
            website_plan_curr: plan.website_plan_curr,
            website_plan_features: plan.website_plan_features,
            website_plan_parent: this.profile.profile_id,
            website_plan_status: plan.website_plan_status,
            website_plan_user: this.profile.profile_user
          };
        } else {
          // Adding New
          this.planForm = {
            website_plan_id: "",
            website_plan_title: "",
            website_plan_price: "",
            website_plan_duration: "",
            website_plan_desc: "",
            website_plan_type: "",
            website_plan_curr: "$",
            website_plan_features: "",
            website_plan_parent: this.profile.profile_id,
            website_plan_status: "active",
            website_plan_user: this.profile.profile_user
          };
        }

        this.showPlanModal = true;
      },
      async savePlan() {
        const fd = new FormData();

        Object.keys(this.planForm).forEach(k => {
          fd.append(k, this.planForm[k]);
        });

        this.isLoading = true;
        const res = await createWebsitePlan(fd);
        this.isLoading = false;

        if (res.status) {
          this.toast.success(res.success);
          this.showPlanModal = false;
          this.loadPricingPackages();
        } else {
          this.toast.error(res.success);
        }
      }
      ,
      async deletePlan(planId) {
        if (!confirm("Delete this plan?")) return;

        const fd = new FormData();
        fd.append("website_plan_id", planId);

        this.isLoading = true;
        const res = await deleteWebsitePlan(planId);
        this.isLoading = false;

        if (res.status) {
          this.toast.success("Deleted");
          this.loadPricingPackages();
        }
      }
      ,
      async loadPricingPackages() {
        const res = await getWebsitePlans(
          "",
          this.profile.profile_id,
          "profile",
          0,
          ""
        );

        if (res.status) {
          this.pricingPackages = res.records.map(p => ({
            ...p,
            features: p.website_plan_features
              ? p.website_plan_features.includes("[")
                ? JSON.parse(p.website_plan_features)
                : p.website_plan_features.split(/\r?\n|,/)
              : []

          }));
          // alert(this.pricingPackages+"");
        }
      }
      ,
      editLocalPlan(i) {
        const p = this.pricingPackages[i];

        this.planForm = {
          index: i,
          title: p.title,
          price: p.price,
          features: p.features.join(", ")
        };

        this.showPlanModal = true;
      },

      saveLocalPlan() {
        const obj = {
          title: this.planForm.title,
          price: this.planForm.price,
          features: this.planForm.features.split(",").map(x => x.trim())
        };

        if (this.planForm.index === null) {
          this.pricingPackages.push(obj);
        } else {
          this.pricingPackages.splice(this.planForm.index, 1, obj);
        }

        this.showPlanModal = false;
      },

      removeLocalPlan(i) {
        if (confirm("Delete this package?")) {
          this.pricingPackages.splice(i, 1);
        }
      },
      async submitComment() {
        if (!this.newComment.name || !this.newComment.rating || !this.newComment.text) {
          this.toast.error("Please fill all fields.");
          return;
        }
        this.isLoading = true;
        const res = await addReview({
          review_profile: this.profile.profile_id,
          review_user: this.profile.profile_user,
          review_name: this.newComment.name,
          review_email: "",
          review_rating: this.newComment.rating,
          review_text: this.newComment.text
        });
        this.isLoading = false;
        if (res.status) {
          this.loadData();
        }

        this.newComment = { name: "", rating: "", text: "" };
      }
      ,
      async removeUGC(i) {
        const media = this.profile.ugc[i];
        this.isLoading = true;
        const res = await deleteMedia(media.media_id);
        this.isLoading = false;
        if (res.status) {
          this.profile.ugc.splice(i, 1);
        }
      }
      ,
      async handleUGCUpload(e) {
        const files = Array.from(e.target.files);

        for (const file of files) {
          const type = file.type.includes("video") ? "video" : "image";

          const fdObj = {
            media_profile: this.profile.profile_id,
            media_user: this.profile.profile_user,
            media_type: type,
            media_status: "1",
            media_url: file
          };
          this.isLoading = true;
          const res = await addOrUpdateMedia(fdObj);
          this.isLoading = false;
          if (res.status) {
            this.profile.ugc.push({
              url: res.media_url,
              type
            });
            this.initUGCPlayers();
          }
        }
      }
      ,
      async uploadAvatar(e) {
        const file = e.target.files[0];
        if (!file) return;

        const fd = new FormData();
        fd.append("file1", file);
        this.isLoading = true;
        const res = await uploadFile(fd);
        this.isLoading = false;
        if (res.status) {
          this.profile.avatar = apiBaseUrl + res.file1;

        }
      }
      ,
      async uploadBanner(e) {
        const file = e.target.files[0];
        if (!file) return;

        const fd = new FormData();
        fd.append("file1", file);
        this.isLoading = true;
        const res = await uploadFile(fd);
        this.isLoading = false;
        if (res.status) {
          // locally preview
          this.profile.banner = apiBaseUrl + res.file1;

        }
      }
      ,
      async saveProfile() {
        // alert(JSON.stringify(this.faqs)+);
        const payload = {
          profile_id: this.profile.profile_id,

          profile_user: this.profile.profile_user,
          profile_banner: this.profile.banner,
          profile_page: JSON.stringify(this.profile.profile_page),
          profile_avatar: this.profile.avatar,
          profile_name: this.profile.name,
          profile_verified: this.profile.verified,
          profile_rating: this.profile.rating,
          profile_review_cnt: this.profile.reviews.length,
          profile_availability: this.profile.availability,
          profile_brand_logos: JSON.stringify(this.profile.brandLogos),

          profile_location: this.profile.location,
          profile_gender: this.profile.gender,
          profile_description: this.profile.description,
          profile_shortdesc: this.profile.description.slice(0, this.profile.shortDescLimit),
          profile_languages: JSON.stringify(this.profile.languages),
          profile_camera: this.profile.camera,
          profile_industries: JSON.stringify(this.profile.industries),
          profile_equipment: JSON.stringify(this.profile.equipment),
          profile_filming: JSON.stringify(this.profile.filming),
          profile_pets: JSON.stringify(this.profile.pets),
          profile_faq: JSON.stringify(this.faqs),

          profile_order_cnt: this.profile.orderCount,
          profile_response_time: this.profile.responseTime,

          profile_score: this.profile.score,
          profile_score_breakdown: JSON.stringify(this.profile.scoreBreakdown),

          profile_username: this.profile.username,
          profile_calender: this.profile.calender,
          profile_email: this.profile.email,
          profile_mobile: this.profile.mobile,
          profile_domain: this.profile.domain
        };
        this.isLoading = true;
        const res = await addOrUpdateProfile(payload);
        this.isLoading = false;
        if (res.status) {
          this.isEdit = false;
        }
        else {
          this.toast.error(res.success + "");
        }
      }

      ,
      editToggleNow() {
        this.isEdit = !this.isEdit;
      }
      ,

      /* =======================
         BRAND LOGO UPLOAD
      ======================= */
      async uploadBrandLogos(e) {
        const files = Array.from(e.target.files);
        if (!files.length) return;

        for (const file of files) {
          // Local preview
          const previewURL = URL.createObjectURL(file);
          this.profile.brandLogos.push(previewURL);


          const fd = new FormData();
          fd.append("file1", file);
          this.isLoading = true;
          const res = await uploadFile(fd);
          this.isLoading = false;
          if (res.status && res.file1) {
            // Replace local preview with real uploaded URL
            const index = this.profile.brandLogos.indexOf(previewURL);
            if (index !== -1) {
              this.profile.brandLogos[index] = res.file1;
            }
          }
        }
      }
      ,

      /* =======================
         ADD LANGUAGES
      ======================= */
      addLanguage() {
        if (!this.languageInput.trim()) return;

        if (!this.profile.languages.includes(this.languageInput)) {
          this.profile.languages.push(this.languageInput);
        }
        this.languageInput = "";
      },

      removeLanguage(i) {
        this.profile.languages.splice(i, 1);
      },

      /* =======================
         CHIP TOGGLES
      ======================= */
      toggleIndustry(ind) {
        const arr = this.profile.industries;
        arr.includes(ind)
          ? arr.splice(arr.indexOf(ind), 1)
          : arr.push(ind);
      },

      toggleEquipment(eq) {
        const arr = this.profile.equipment;
        arr.includes(eq)
          ? arr.splice(arr.indexOf(eq), 1)
          : arr.push(eq);
      },

      toggleFilming(f) {
        const arr = this.profile.filming;
        arr.includes(f)
          ? arr.splice(arr.indexOf(f), 1)
          : arr.push(f);
      },

      togglePet(p) {
        const arr = this.profile.pets;
        arr.includes(p)
          ? arr.splice(arr.indexOf(p), 1)
          : arr.push(p);
      },


      /* =======================
         FAQ LOGIC
      ======================= */
      toggleFAQ(i) {
        this.profile.faq[i].open = !this.profile.faq[i].open;
      },

      /* Edit FAQ Existing */


      /* Close Modal */
      closeFAQModal() {
        this.showFAQModal = false;
      },

      /* Save FAQ */

      safeJSON(value, fallback) {
        if (!value) return fallback;
        try {
          return JSON.parse(value);
        } catch (e) {
          return fallback;
        }
      }
      ,
      isProfileEmpty(p) {
        if (!p) return true;

        const fieldsToCheck = [
          p.profile_banner,
          p.profile_avatar,
          p.profile_name,
          p.profile_username,
          p.profile_page,
          p.profile_calender,
          p.profile_email,
          p.profile_mobile,
          p.profile.domain,
          p.profile_location,
          p.profile_description,
          p.profile_gender,
          p.profile_languages,
          p.profile_industries,
        ];

        // If every field is empty → treat as new profile
        return fieldsToCheck.every(v => !v || v === "null" || v === "undefined" || v.length === 0);
      }
      ,
      async loadMedia(page_no = 0) {
        const media = await getMediaList(this.profile.profile_id, page_no);
        if (media.status) {
          this.profile.ugc = media.records.map(x => ({
            url: x.media_url,
            type: x.media_type
          }));
        }
        this.initUGCPlayers();
      },
      async loadReview(page_no = 0) {
        const rev = await getReviewList(this.profile.profile_id, page_no);
        if (rev.status) {
          this.profile.reviews = rev.records.map(x => ({
            name: x.review_name,
            rating: x.review_rating,
            text: x.review_text,
            date: x.review_date
          }));
        }
      },

      async loadData() {
        this.isLoading = true;
        try {
          const res = await getProfileByUserId(this.profile.username);

          if (res.status && res.profile) {
            const p = res.profile;
            const web_dt = res.web_dt;
            try {
              if(web_dt!=null && web_dt.web_script!=null && web_dt.web_script.length>0){
                const prop_dt = JSON.parse(web_dt.web_script);
                if(prop_dt!=null && prop_dt.your_script!=null && prop_dt.your_script.length>0){
                  this.loadGAScript(prop_dt.your_script+"");
                }
              }
            }
            catch (e) {
              console.log("sdas12", e);
            }

            // Primitive fields
            this.profile.profile_id = p.profile_id || "";
            this.profile.profile_user = p.profile_user || "";

            this.profile.banner = p.profile_banner || this.profile.banner;
            this.profile.avatar = p.profile_avatar || this.profile.avatar;
            this.profile.name = p.profile_username || "";
            this.profile.username = p.profile_username || "";
            this.profile.calender = p.profile_calender || "";
            this.profile.email = p.profile_email || "";
            this.profile.mobile = p.profile_mobile || "";
            this.profile.domain = p.profile_domain || "";

            this.profile.location = p.profile_location || "";
            this.profile.gender = p.profile_gender || "";
            this.profile.description = p.profile_description || "";

            this.profile.verified = p.profile_verified == "1";
            this.profile.rating = Number(p.profile_rating || 0);
            this.profile.reviewCount = Number(p.profile_review_cnt || 0);
            this.profile.availability = p.profile_availability || "";
            this.profile.status = p.profile_status || "";

            // Arrays (SAFE PARSE)
            this.profile.profile_page = this.safeJSON(p.profile_page, {
              instagram: "",
              youtube: "",
              x: "",
              linkedin: ""
            });

            this.profile.languages = this.safeJSON(p.profile_languages, []);
            this.profile.industries = this.safeJSON(p.profile_industries, []);
            this.profile.equipment = this.safeJSON(p.profile_equipment, []);
            this.profile.filming = this.safeJSON(p.profile_filming, []);
            this.profile.pets = this.safeJSON(p.profile_pets, []);

            // Others
            this.profile.camera = p.profile_camera || "";
            this.profile.orderCount = Number(p.profile_order_cnt || 0);
            this.profile.responseTime = p.profile_response_time || "";

            this.profile.score = Number(p.profile_score || 0);
            this.profile.scoreBreakdown = this.safeJSON(p.profile_score_breakdown, []);

            this.profile.brandLogos = this.safeJSON(p.profile_brand_logos, []);

            this.syncCustomChips(this.industries, this.profile.industries);
            this.syncCustomChips(this.equipments, this.profile.equipment);
            this.syncCustomChips(this.filmingTypes, this.profile.filming);
            this.faqs = this.safeJSON(p.profile_faq, this.dummyFAQs);
            
            // if (this.isProfileEmpty(p)) {
            //   this.isEdit = true;
            // }

          }
          else {
            this.isEdit = true;
          }
        }
        catch (e) {
          console.log("sdas", e);
        }
        finally {
          this.isLoading = false;
        }
        await this.loadMedia(0);
        await this.loadReview(0);
        await this.loadPricingPackages();
        await this.fetchPages();

      },
    },
    beforeMount() {
      const domain = this.$route.params.user_id + ".com";

      if (!window.__plausibleInjected) {
        window.__plausibleInjected = true;
        const script =
          "<scr" +
          'ipt async defer data-domain="' +
          domain +
          '" data-api="https://api.analytcly.ai/pls/event" ' +
          'src="https://api.analytcly.ai/pls/script"></scr' +
          "ipt>";

        document.write(script);
        console.log("dsfsmdkfmsdkfmdone34");
      }
    },
    async mounted() {
      this.isEditorMode = this.$route.query.edit || null;
      this.base_url = apiBaseUrl;
      this.base_url1 = mainBaseUrl;
      this.profile.username = this.$route.params.user_id;
      this.loadData();
      
    }

  };
</script>
<style scoped>
  .dns-info {
    margin-top: 1.2rem;
    background: #f9fafb;
    border-radius: 10px;
    padding: 1rem 1.2rem;
    border: 1px solid #e5e7eb;
  }

  .dns-info h6 {
    font-weight: 600;
    color: #111827;
    font-size: 0.95rem;
    margin-bottom: 0.5rem;
  }

  .dns-info ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .dns-info li {
    color: #374151;
    font-size: 0.85rem;
    margin-bottom: 0.3rem;
  }

  /* ===============================
   GLOBAL WRAPPER
================================*/
  .profile-page {
    width: 100%;
    padding: 0 0 40px 0;
  }

  /* ===============================
   HEADER: BANNER + AVATAR
================================*/
  .profile-header {
    width: 100%;
    position: relative;
  }

  .banner-wrapper {
    width: 100%;
    height: 230px;
    position: relative;
    overflow: hidden;
    border-radius: var(--radius);
    border: 1px solid var(--border);
    background: var(--card);
  }

  .banner-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .banner-edit-btn {
    position: absolute;
    bottom: 12px;
    left: 12px;
    background: #fff;
    padding: 8px 14px;
    border-radius: var(--radius);
    border: 1px solid var(--border);
    font-size: 14px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font-weight: 500;
  }

  .profile-info-row {
    width: 97%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    margin-top: -40px;
  }

  .avatar-block {
    display: flex;
    gap: 16px;
    align-items: flex-end;
  }

  .avatar-wrapper {
    position: relative;
  }

  .avatar-img {
    width: 110px;
    height: 110px;
    border-radius: 100%;
    border: 3px solid #fff;
    object-fit: cover;
  }

  .avatar-edit-btn {
    position: absolute;
    bottom: 0;
    right: 0;
    background: #fff;
    width: 32px;
    height: 32px;
    border-radius: 100%;
    border: 1px solid var(--border);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  /* ===============================
   NAME + RATING
================================*/
  .profile-name-rating {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .name-row {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .name-row h2 {
    font-size: 22px;
    font-weight: 700;
    margin: 0;
    color: var(--text);
  }

  .verified-icon {
    color: #10b981;
    font-size: 20px;
  }

  .rating-row {
    display: flex;
    align-items: center;
    gap: 4px;
    color: #facc15;
    font-weight: 600;
    font-size: 15px;
  }

  .rating-text {
    color: var(--text);
    font-weight: 600;
  }

  .availability {
    background: #e0ffe8;
    color: #10b981;
    padding: 3px 10px;
    border-radius: 20px;
    font-size: 13px;
    width: fit-content;
  }

  /* Contact Button */
  .contact-btn-wrapper {
    display: flex;
    align-items: flex-end;
  }

  .contact-btn {
    padding: 9px 18px;
  }

  /* ===============================
   MAIN GRID LAYOUT
================================*/
  .profile-layout {
    display: grid;
    grid-template-columns: 70% 28%;
    gap: 20px;
  }

  /* ===============================
   LEFT COLUMN CARDS
================================*/
  .left-column .card {
    background: var(--card);
    border: 1px solid var(--border);
    border-radius: var(--radius);
    padding: 20px;
    margin-bottom: 22px;
  }

  /* ===============================
   DETAIL ROWS (Preview)
================================*/
  .detail-row {
    display: flex;
    justify-content: space-between;
    padding: 7px 0;
    border-bottom: 1px dashed var(--border);
    font-size: 14px;
  }

  .detail-row .label {
    color: var(--muted);
  }

  .detail-row i {
    margin-right: 6px;
  }

  /* ===============================
   DESCRIPTION PREVIEW
================================*/
  .description-block {
    margin-top: 14px;
    font-size: 14px;
    line-height: 1.5;
    color: var(--text);
  }

  .see-more {
    color: var(--primary);
    cursor: pointer;
    font-weight: 600;
  }

  /* ===============================
   EDIT MODE FIELDS
================================*/
  .field-label {
    font-size: 14px;
    font-weight: 600;
    margin-top: 14px;
    margin-bottom: 6px;
    display: block;
  }

  /* Chips */
  .chip {
    padding: 7px 14px;
    border-radius: 20px;
    font-size: 13px;
    border: 1px solid var(--border);
    background: #fff;
    cursor: pointer;
    margin-bottom: 8px;
    display: inline-flex;
    align-items: center;
  }

  .chip.active {
    background: var(--primary);
    color: #fff;
    border-color: var(--primary);
  }

  .chip-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .chip-row {
    display: flex;
    gap: 8px;
  }

  /* ===============================
   BRAND LOGO UPLOAD
================================*/
  .upload-btn {
    padding: 8px 14px;
    border: 1px solid var(--border);
    background: #fff;
    border-radius: var(--radius);
    cursor: pointer;
    font-size: 14px;
    display: inline-flex;
    align-items: center;
    gap: 8px;
  }

  .brand-logo-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 12px;
  }

  .brand-logo-img {
    width: 90px;
    height: 40px;
    object-fit: contain;
    border: 1px solid var(--border);
    border-radius: var(--radius);
    background: #fff;
  }

  /* ===============================
   UGC GRID
================================*/
  .ugc-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .ugc-upload-btn {
    padding: 6px 14px;
    border: 1px solid var(--border);
    background: #fff;
    border-radius: var(--radius);
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }

  .ugc-grid {
    margin-top: 14px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
  }

  .media-card {
    border-radius: var(--radius);
    border: 1px solid var(--border);
    overflow: hidden;
    position: relative;
  }

  .media-card img,
  .media-card video {
    width: 100%;
    height: 160px;
    object-fit: cover;
    display: block;
  }

  .delete-btn {
    position: absolute;
    top: 8px;
    right: 8px;
    background: #fff;
    border: 1px solid var(--border);
    width: 28px;
    height: 28px;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  /* Show more */
  .show-more-btn {
    margin-top: 14px;
    width: 100%;
    padding: 8px 14px;
    border-radius: var(--radius);
    border: 1px solid var(--border);
    background: #fff;
    cursor: pointer;
  }

  /* ===============================
   FAQ
================================*/
  .faq-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .faq-item {
    border-bottom: 1px dashed var(--border);
    padding: 12px 0;
    position: relative;
  }

  .faq-question {
    display: flex;
    justify-content: space-between;
    cursor: pointer;
  }

  .faq-question i {
    transition: 0.3s;
  }

  .faq-question i.open {
    transform: rotate(180deg);
  }

  .faq-answer {
    margin-top: 8px;
    font-size: 14px;
    color: var(--muted);
  }

  .faq-edit-actions {
    display: flex;
    gap: 8px;
    margin-top: 10px;
  }

  .chip.small {
    padding: 4px 10px;
    font-size: 12px;
  }

  .chip.red {
    background: #ffe9e9;
    color: #d20000;
    border-color: #ffb3b3;
  }

  /* ===============================
   MAP
================================*/
  .map-iframe {
    width: 100%;
    height: 260px;
    border-radius: var(--radius);
    border: 1px solid var(--border);
    margin-top: 10px;
  }

  /* ===============================
   REVIEWS
================================*/
  .review-stats {
    display: flex;
    gap: 20px;
    margin-bottom: 16px;
  }

  .big-rating {
    font-size: 36px;
    font-weight: 700;
    color: #facc15;
  }

  .big-rating i {
    font-size: 36px;
  }

  .rating-bars {
    width: 100%;
  }

  .rating-bar-row {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 4px;
  }

  .bar-container {
    flex: 1;
    height: 8px;
    background: #eee;
    border-radius: 4px;
  }

  .bar-fill {
    height: 8px;
    background: #facc15;
    border-radius: 4px;
  }

  .review-card {
    padding: 12px 0;
    border-bottom: 1px solid var(--border);
  }

  .review-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 4px;
  }

  .review-date {
    font-size: 12px;
    color: var(--muted);
  }

  /* ===============================
   EDIT USERNAME
================================*/
  .save-btn {
    margin-top: 10px;
  }

  /* ===============================
   RIGHT SIDEBAR
================================*/
  .right-column .sidebar-card {
    background: var(--card);
    border: 1px solid var(--border);
    border-radius: var(--radius);
    padding: 20px;
    margin-bottom: 22px;
  }

  /* Visibility Alert */
  .alert-card {
    border-left: 4px solid #ff3d3d;
    background: #fff5f5;
  }

  .alert-title {
    font-weight: 700;
    font-size: 15px;
    color: #c80000;
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .alert-subtitle {
    margin-top: 10px;
    font-size: 14px;
    color: var(--text);
  }

  .alert-list li {
    padding: 6px 0;
    font-size: 14px;
    display: flex;
    gap: 6px;
  }

  /* Pricing Cards */
  .pricing-card .pricing-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .pricing-card .price {
    font-size: 20px;
    font-weight: 700;
  }

  .feature-list li {
    padding: 4px 0;
    font-size: 14px;
    display: flex;
    gap: 6px;
  }

  .full-btn {
    width: 100%;
    margin-top: 12px;
    padding: 10px;
  }

  /* ===============================
   PROFILE SCORE — EXACT PDF STYLE
=================================*/

  .score-card {
    padding: 18px 20px !important;
    border-radius: var(--radius);
    border: 1px solid var(--border);
    background: var(--card);
  }

  /* Title */
  .score-card h3 {
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 14px;
    color: var(--text);
  }

  /* Progress Bar Outer */
  .score-card .progress-bar {
    width: 100%;
    height: 14px;
    /* PDF is thicker */
    background: #e6e6e6;
    border-radius: 40px;
    overflow: hidden;
    position: relative;
    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.08);
    margin-bottom: 18px;
  }

  /* Progress Bar Fill */
  .score-card .progress-fill {
    height: 100%;
    background: #111827;
    /* PDF dark navy */
    border-radius: 40px;
    transition: width 0.4s ease;
  }

  /* Score Improvement List */
  .score-list {
    margin-top: 4px;
  }

  .score-list li {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    font-size: 14px;
    color: var(--text);

    border-bottom: 1px dotted #d7d7d7;
    /* PDF dotted divider */
  }

  /* Remove last dot line */
  .score-list li:last-child {
    border-bottom: none;
  }

  /* Right side percentage */
  .score-list li .right {
    font-weight: 700;
    color: #111827;
    /* PDF color */
    font-size: 14px;
  }

  /* ===============================
   RESPONSIVE
================================*/
  @media (max-width: 1100px) {
    .profile-layout {
      grid-template-columns: 100%;
    }
  }

  @media (max-width: 768px) {
    .banner-img {
      height: 170px;
    }

    .avatar-img {
      width: 90px;
      height: 90px;
    }

    .ugc-grid {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  @media (max-width: 480px) {
    .ugc-grid {
      grid-template-columns: 1fr;
    }
  }

  /* ===============================
   HEADER — EXACT PDF REPLICA
================================*/

  .profile-header {
    width: 100%;
    position: relative;
  }

  /* ====== Banner ====== */
  .banner-box {
    width: 100%;
    height: 240px;
    border-radius: var(--radius);
    border: 1px solid var(--border);
    overflow: hidden;
    background: var(--card);
    position: relative;
  }

  .banner-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  /* Banner Upload Bar */
  .banner-upload-bar {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    background: rgba(255, 255, 255, 0.92);
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 16px;
    font-size: 14px;
    font-weight: 500;
    border-top: 1px solid var(--border);
    cursor: pointer;
  }


  /* ===== TOP ROW ===== */
  .profile-top-row {
    display: flex;
    justify-content: space-between;
    padding: 0 20px;
    margin-top: -55px;
  }

  /* Left Side Stack */
  .header-left-stack {
    display: flex;
    gap: 16px;
    align-items: flex-end;
  }

  /* Avatar */
  .avatar-container {
    position: relative;
  }

  .avatar-img {
    width: 115px;
    height: 115px;
    border-radius: 100%;
    border: 4px solid #fff;
    object-fit: cover;
  }

  .avatar-edit-icon {
    position: absolute;
    bottom: 0;
    right: 4px;
    background: #fff;
    width: 34px;
    height: 34px;
    border-radius: 50%;
    border: 1px solid var(--border);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  /* Info stack */
  .info-stack {
    display: flex;
    flex-direction: column;
    gap: 5px;
    margin-bottom: 8px;
  }

  /* Name line */
  .name-line {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .name-line h2 {
    margin: 0;
    font-size: 22px;
    font-weight: 700;
    color: var(--text);
  }

  .verified-icon {
    font-size: 20px;
    color: #10b981;
  }

  /* Rating */
  .rating-line {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .star-icon {
    font-size: 18px;
    color: #facc15;
  }

  .rating-value {
    font-weight: 700;
    color: var(--text);
  }

  .rating-count {
    font-size: 14px;
    color: var(--muted);
  }

  /* Availability */
  .availability-pill {
    background: #eaffeb;
    color: #22c55e;
    padding: 4px 12px;
    border-radius: 14px;
    font-size: 13px;
    width: fit-content;
  }

  /* Contact Button */
  .header-contact-col {
    display: flex;
    align-items: flex-end;
  }

  .contact-btn {
    background: #111827;
    color: #fff;
    display: flex;
    align-items: center;
    gap: 8px;
    border: none;
    border-radius: var(--radius);
    padding: 10px 22px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
  }

  .score-card {
    overflow: visible !important;
  }

  /* ======================================================
   MISSING CSS — REQUIRED FOR FULL TEMPLATE FUNCTIONALITY
   These classes exist in template but missing in your CSS
========================================================= */

  /* ---------------------------
   TAGS INPUT (Languages)
----------------------------*/
  .tags-input {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    padding: 8px;
    border: 1px solid var(--border);
    border-radius: var(--radius);
    background: #fff;
  }

  .tags-input input {
    border: none;
    outline: none;
    flex: 1;
    font-size: 14px;
    padding: 4px;
  }

  .tag {
    background: #f3f4f6;
    padding: 6px 10px;
    border-radius: 20px;
    font-size: 13px;
    display: flex;
    align-items: center;
    gap: 6px;
    border: 1px solid var(--border);
  }

  .tag i {
    cursor: pointer;
    font-size: 14px;
  }

  /* ---------------------------
   BRAND UPLOAD ROW
----------------------------*/
  .brand-upload-row {
    display: flex;
    margin-top: 12px;
  }

  /* ---------------------------
   UGC Delete Icon
----------------------------*/
  .delete-btn i {
    font-size: 16px;
    color: #111;
  }

  /* ---------------------------
   FAQ Toggle Switch Area
----------------------------*/
  .toggle-label {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    cursor: pointer;
  }

  /* ---------------------------
   Rating Stars in Reviews
----------------------------*/
  .review-header .rating {
    display: flex;
    align-items: center;
    gap: 4px;
    color: #facc15;
    font-weight: 600;
  }

  /* ---------------------------
   USERNAME SAVE BUTTON
----------------------------*/
  .save-btn {
    width: 100%;
    margin-top: 12px;
    padding: 10px;
  }

  /* ---------------------------
   RIGHT SIDEBAR STRUCTURE
----------------------------*/
  .right-column {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  /* ---------------------------
   FULL WIDTH BUTTON IN SIDEBAR
----------------------------*/
  .full-btn {
    width: 100%;
    font-weight: 600;
    padding: 10px 14px;
    border-radius: var(--radius);
  }

  /* ---------------------------
   SCORE LIST (clean spacing)
----------------------------*/
  .score-list {
    margin-top: 12px;
  }

  .score-list .right {
    min-width: 40px;
    text-align: right;
  }

  /* ---------------------------
   QUICK STATS
----------------------------*/
  .stats-list {
    margin-top: 10px;
  }

  .stats-list li {
    padding: 6px 0;
    font-size: 14px;
  }

  /* ---------------------------
   FIX: PROFILE HEADER SPACING
----------------------------*/
  .profile-top-row {
    align-items: flex-end;
  }

  /* ---------------------------
   FIX: Banner upload icon
----------------------------*/
  .banner-upload-bar i {
    font-size: 18px;
    color: var(--text);
  }

  /* ---------------------------
   FIX: Avatar camera icon
----------------------------*/
  .avatar-edit-icon i {
    font-size: 18px;
    color: var(--text);
  }

  /* ---------------------------
   FIX: Score Card visibility
----------------------------*/
  .sidebar-card.score-card {
    overflow: visible !important;
  }

  /* =====================================================
   YOU DJI SCORE PROGRESS BAR — FINAL FIX (FORCED)
======================================================*/
  .score-card .progress-bar {
    width: 100% !important;
    height: 14px !important;
    background: #e6e6e6 !important;
    border-radius: 40px !important;
    overflow: hidden !important;
    position: relative !important;
    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.08) !important;
    margin: 14px 0 18px 0 !important;
  }

  .score-card .progress-fill {
    height: 100% !important;
    background: #111827 !important;
    border-radius: 40px !important;
    transition: width 0.4s ease !important;
  }

  /* ============================================
   FIXED & FINAL .btn-primary STYLING
   (PDF-accurate + your theme style)
============================================ */

  .btn-primary {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;

    background: var(--primary);
    color: #fff;

    padding: 10px 18px;
    font-size: 14px;
    font-weight: 600;

    border: none;
    border-radius: var(--radius);
    cursor: pointer;

    transition: all 0.25s ease;
    box-shadow: 0 2px 6px rgba(17, 24, 39, 0.15);
  }

  .btn-primary i {
    font-size: 18px;
  }

  .btn-primary:hover {
    background: var(--primary-dark);
    transform: translateY(-1px);
    box-shadow: 0 3px 12px rgba(17, 24, 39, 0.25);
  }

  .btn-primary:active {
    transform: translateY(0);
    box-shadow: 0 1px 3px rgba(17, 24, 39, 0.15);
  }

  /* Full-width special button (sidebar + username save) */
  .full-btn {
    width: 100%;
  }

  /* =============================================
   UNIVERSAL INPUT STYLING (PDF + your theme)
============================================= */

  .input-theme,
  .textarea-theme,
  select.input-theme {
    width: 100%;
    padding: 7px 12px;
    /* reduced from 10px 14px */
    font-size: 14px;
    color: var(--text);
    background: #fff;

    border: 1px solid var(--border);
    border-radius: var(--radius);

    outline: none;
    transition: 0.2s ease;
  }


  .input-theme:focus,
  .textarea-theme:focus,
  select.input-theme:focus {
    border-color: var(--primary);
    box-shadow: 0 0 0 2px rgba(var(--primary-rgb), 0.12);
  }

  /* Select Arrow Fix (Force clean arrow like PDF) */
  select.input-theme {
    appearance: none;
    background-image: url("data:image/svg+xml;charset=UTF-8,<svg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M1 1L6 6L11 1' stroke='%23888' stroke-width='2' stroke-linecap='round'/></svg>");
    background-repeat: no-repeat;
    background-position: right 14px center;
    background-size: 12px;
  }

  /* Textarea */
  .textarea-theme {
    min-height: 110px;
    resize: vertical;
  }

  /* =============================================
   TAGS INPUT (Languages)
============================================= */

  .tags-input {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px;

    width: 100%;
    padding: 8px;
    background: #fff;

    border: 1px solid var(--border);
    border-radius: var(--radius);
  }

  .tags-input input {
    border: none;
    padding: 6px;
    font-size: 14px;
    flex: 1;
    outline: none;
  }

  .tag {
    background: var(--primary-light);
    color: var(--primary);
    border-radius: 20px;
    padding: 6px 10px;
    font-size: 13px;

    display: flex;
    align-items: center;
    gap: 6px;
  }

  .tag i {
    font-size: 16px;
    cursor: pointer;
  }

  /* =============================================
   LABELS (PDF accurate)
============================================= */

  .field-label {
    margin-top: 14px;
    margin-bottom: 6px;
    font-size: 14px;
    font-weight: 600;
    color: var(--text);
  }

  /* ============================================
   HEADER EXTRA FIELDS (Preview Only)
============================================ */

  .header-extra-details {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    background: var(--card);
    border: 1px solid var(--border);
    border-radius: var(--radius);
    padding: 20px;
    margin-top: 1rem;
    padding: 1rem;
  }

  .header-field-row {
    font-size: 14px;
    color: var(--text);
    display: flex;
    margin-bottom: .4rem;
    gap: 6px;
  }

  .field-label-small {
    font-weight: 600;
    color: var(--muted);
  }

  .field-value-small {
    color: var(--text);
  }

  /* ===============================
   COMMENT FORM SECTION
================================*/

  .comment-card {
    margin-top: 20px;
  }

  .comment-form-row {
    margin-bottom: 14px;
  }

  .comment-card h3 {
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 14px;
    color: var(--text);
  }

  .comment-card .btn-primary {
    margin-top: 10px;
  }

  /* ============================
   FAQ POPUP MODAL
============================*/
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.55);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9000;
  }

  .modal-box {
    background: #fff;
    width: 420px;
    max-width: 90%;
    padding: 24px;
    border-radius: var(--radius);
    border: 1px solid var(--border);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  }

  .modal-box h3 {
    margin-top: 0;
    margin-bottom: 12px;
  }

  .modal-actions {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
    gap: 10px;
  }

  /* Floating button */
  .chat-button {
    position: fixed;
    bottom: 25px;
    right: 25px;
    background: #111827;
    color: #fff;
    width: 55px;
    height: 55px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 26px;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.25);
    z-index: 999999;
    /* increase */
  }

  /* Chatbox window */
  .chatbox-container {
    position: fixed;
    bottom: 95px;
    /* sits ABOVE the chat-button */
    right: 25px;
    width: 330px;
    height: 430px;

    background: #fff;
    border-radius: 14px;
    border: 1px solid var(--border);
    box-shadow: 0 8px 22px rgba(0, 0, 0, 0.25);

    display: flex;
    flex-direction: column;
    overflow: hidden;

    z-index: 999999;
    /* same top level */
  }

  /* Header */
  .chatbox-header {
    padding: 12px 16px;
    background: #111827;
    color: #fff;
    display: flex;
    justify-content: space-between;
    font-size: 15px;
  }

  /* Messages */
  .chatbox-messages {
    flex: 1;
    padding: 12px;
    overflow-y: auto;
  }

  .msg {
    max-width: 80%;
    padding: 8px 12px;
    margin-bottom: 8px;
    border-radius: 12px;
    line-height: 1.4;
  }

  .msg.user {
    background: #dbeafe;
    align-self: flex-end;
  }

  .msg.ai {
    background: #e5e7eb;
    align-self: flex-start;
  }

  /* Input */
  .chatbox-input {
    display: flex;
    border-top: 1px solid var(--border);
  }

  .chatbox-input input {
    flex: 1;
    padding: 10px;
    border: none;
    outline: none;
  }

  .chatbox-input button {
    background: #111827;
    color: #fff;
    width: 50px;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /* ============================
   MOBILE RESPONSIVE PATCH
   (Safe to paste at bottom)
============================ */

  /* ===== Tablet & Mobile (<=768px) ===== */
  @media (max-width: 768px) {

    /* TOP HEADER STACK FIX */
    .profile-top-row {
      flex-direction: column;
      align-items: center;
      text-align: center;
      margin-top: -40px;
      gap: 12px;
    }

    .header-left-stack {
      flex-direction: column;
      align-items: center;
      text-align: center;
    }

    .info-stack {
      align-items: center;
    }

    .header-contact-col {
      flex-direction: row;
      justify-content: center;
      width: 100%;
      margin-top: 10px;
      gap: 10px;
    }

    /* Avatar */
    .avatar-img {
      width: 95px !important;
      height: 95px !important;
    }

    /* Banner height */
    .banner-box {
      height: 180px !important;
    }

    /* MAIN GRID → SINGLE COLUMN */
    .profile-layout {
      display: flex;
      flex-direction: column;
    }

    .right-column {
      width: 100%;
    }

    /* Cards spacing */
    .left-column .card,
    .right-column .sidebar-card {
      margin-bottom: 18px;
    }

    /* UGC Grid → 2 Columns */
    .ugc-grid {
      grid-template-columns: repeat(2, 1fr) !important;
    }

    /* FAQ Text */
    .faq-question h4 {
      font-size: 15px;
    }

    /* Map */
    .map-iframe {
      height: 200px !important;
    }

    /* Chatbox fix on mobile */
    .chatbox-container {
      right: 12px;
      width: 300px;
      height: 420px;
    }

    .chat-button {
      right: 12px;
    }
  }

  /* ===== Small Mobiles (<=480px) ===== */
  @media (max-width: 480px) {

    .banner-box {
      height: 150px !important;
    }

    /* Avatar center */
    .avatar-img {
      width: 80px !important;
      height: 80px !important;
    }

    /* Name */
    .name-line h2 {
      font-size: 18px !important;
    }

    .contact-btn {
      padding: 8px 14px !important;
      font-size: 13px !important;
    }

    /* UGC Grid → 1 Column */
    .ugc-grid {
      grid-template-columns: 1fr !important;
    }

    /* Sidebar cards full width */
    .sidebar-card {
      padding: 16px !important;
    }

    .modal-box {
      width: 92% !important;
    }

    .chatbox-container {
      width: 92% !important;
      right: 4%;
    }
  }

  /* ============================================
   GLOBAL PAGE WRAPPER — EXACT July toss MARGINS
   Matches spacing seen in PDF (page 1)
============================================ */
  .profile-page {
    width: 100%;
    max-width: 80rem;
    /* prevents too-wide screens */
    margin: 0 auto;
    /* centers the whole page */
    padding: 3rem 32px 40px;
    /* clean page margin */
    box-sizing: border-box;
  }

  /* Adjust inner layout spacing */
  .profile-layout {
    margin-top: 1.5rem;
    gap: 28px !important;
  }

  /* Cards unified spacing */
  .left-column .card,
  .right-column .sidebar-card {
    border-radius: 12px;
    padding: 22px;
  }

  /* ============================================
   TABLET (matches July toss compressed look)
============================================ */
  @media (max-width: 992px) {
    .profile-page {
      padding: 0 22px 40px;
    }

    .profile-layout {
      flex-direction: column !important;
    }

    .right-column {
      width: 100% !important;
    }
  }

  /* ============================================
   MOBILE (matches PDF page spacing)
============================================ */
  @media (max-width: 600px) {
    .profile-page {
      padding: 0 16px 32px;
      /* tighter like PDF */
    }

    .profile-top-row {
      padding: 0 10px !important;
    }

    .left-column .card,
    .right-column .sidebar-card {
      padding: 16px !important;
    }
  }

  .brand-item {
    position: relative;
    width: 90px;
    height: 40px;
  }

  .brand-item img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border: 1px solid var(--border);
    border-radius: var(--radius);
    background: #fff;
  }

  .brand-delete {
    position: absolute;
    top: -8px;
    right: -8px;
    background: #fff;
    border: 1px solid #ddd;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  .brand-delete i {
    font-size: 14px;
    color: #d00;
  }

  .calendar-placeholder {
    width: 100%;
    height: 200px;
    margin-top: 1rem;
    border: 1px dashed #ccc;
    border-radius: 10px;
    background: #fafafa;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    color: #999;
    font-size: 16px;
    gap: 10px;
  }

  .calendar-placeholder i {
    font-size: 40px;
    color: #bbb;
  }

  /* Smooth FAQ box */
  .faq-item.improved {
    padding: 14px 0;
    border-bottom: 1px solid #eee;
  }

  /* Question Row */
  .faq-question {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
  }

  .faq-question h4 {
    font-size: 15px;
    font-weight: 600;
    color: #111;
  }

  .faq-question i {
    font-size: 20px;
    color: #777;
    transition: .25s;
  }

  .faq-question i.open {
    transform: rotate(180deg);
  }

  /* Answer */
  .faq-answer {
    margin-top: 10px;
    padding-left: 4px;
  }

  .faq-text {
    font-size: 14px;
    color: #555;
    line-height: 1.55;
    margin-bottom: 14px;
  }

  /* ACTIONS BAR */
  .faq-actions-bar {
    display: flex;
    align-items: center;
    gap: 10px;

    padding: 10px;
    background: #f9fafb;
    border: 1px solid #eee;
    border-radius: 8px;
  }

  /* Action Buttons */
  .faq-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;

    padding: 6px 12px;
    font-size: 13px;
    font-weight: 600;

    border-radius: 6px;
    border: none;
    cursor: pointer;
  }

  .faq-btn i {
    font-size: 16px;
  }

  /* Edit */
  .faq-btn.edit {
    background: #e0f2fe;
    color: #0369a1;
  }

  /* Delete */
  .faq-btn.delete {
    background: #fee2e2;
    color: #b91c1c;
  }

  /* Publish Toggle */
  .publish-switch {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
  }

  /* ===========================
   SOCIAL PROFILE CARD
=========================== */

  .social-grid {
    display: flex;
    gap: 14px;
    flex-wrap: wrap;
  }

  .social-btn {
    width: 46px;
    height: 46px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    color: #fff;
    cursor: pointer;
    transition: .25s ease;
    text-decoration: none;
  }

  .social-btn:hover {
    transform: translateY(-3px);
  }

  /* Platform colors */

  .social-btn.instagram {
    background: #e1306c;
  }

  .social-btn.youtube {
    background: #ff0000;
  }

  .social-btn.x {
    background: #111827;
  }

  .social-btn.linkedin {
    background: #0a66c2;
  }

  /* ======================================================
   🔥 HARD ALIGNMENT FIXES (GLOBAL)
====================================================== */

  * {
    box-sizing: border-box;
  }

  img,
  video,
  iframe {
    max-width: 100%;
    height: auto;
  }

  /* Prevent horizontal scroll */
  .profile-page,
  .profile-layout {
    overflow-x: hidden;
  }

  /* ======================================================
   HEADER STRUCTURE FIX
====================================================== */

  .profile-top-row {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 16px;
  }

  .header-left-stack {
    display: flex;
    align-items: flex-end;
    gap: 16px;
  }

  .info-stack {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  /* Prevent buttons wrapping ugly */
  .header-contact-col {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
  }

  /* ======================================================
   TWO COLUMN LAYOUT STABILITY
====================================================== */

  .profile-layout {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 380px);
    gap: 28px;
  }

  .left-column,
  .right-column {
    min-width: 0;
  }

  /* ======================================================
   CARD CONSISTENCY
====================================================== */

  .left-column .card,
  .right-column .sidebar-card {
    background: #fff;
    border-radius: 12px;
    padding: 20px;
  }

  /* ======================================================
   CHIP SAFETY
====================================================== */

  .chip,
  .tag {
    white-space: nowrap;
  }

  /* ======================================================
   GRID SAFETY
====================================================== */

  .brand-logo-grid,
  .chip-grid,
  .social-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }

  /* ======================================================
   UGC GRID
====================================================== */

  .ugc-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 12px;
  }

  /* ======================================================
   BUTTONS
====================================================== */

  .contact-btn,
  .btn-primary,
  .full-btn {
    white-space: nowrap;
  }

  /* ======================================================
   CHAT WINDOW
====================================================== */

  .chatbox-container {
    max-width: 92vw;
  }

  /* ======================================================
   TABLET FIX (<=1024px)
====================================================== */

  @media (max-width: 1024px) {

    .profile-layout {
      grid-template-columns: 1fr;
    }

    .right-column {
      width: 100%;
    }

  }

  /* ======================================================
   MOBILE FIX (<=768px)
====================================================== */

  @media (max-width: 768px) {

    /* Header stack */
    .profile-top-row {
      flex-direction: column;
      align-items: center;
      text-align: center;
      margin-top: -40px;
    }

    .header-left-stack {
      flex-direction: column;
      align-items: center;
    }

    .info-stack {
      align-items: center;
    }

    .header-contact-col {
      justify-content: center;
      width: 100%;
    }

    /* Avatar */
    .avatar-img {
      width: 90px !important;
      height: 90px !important;
    }

    /* Banner */
    .banner-box {
      height: 170px !important;
    }

    /* One column layout */
    .profile-layout {
      display: flex;
      flex-direction: column;
    }

    /* UGC */
    .ugc-grid {
      grid-template-columns: repeat(2, 1fr);
    }

    /* Buttons full width */
    .header-contact-col button,
    .full-btn {
      width: 100%;
      justify-content: center;
    }

    /* Cards spacing */
    .left-column .card,
    .right-column .sidebar-card {
      padding: 16px;
    }

  }

  /* ======================================================
   SMALL MOBILE (<=480px)
====================================================== */

  @media (max-width: 480px) {

    .banner-box {
      height: 145px !important;
    }

    .avatar-img {
      width: 78px !important;
      height: 78px !important;
    }

    .name-line h2 {
      font-size: 18px;
    }

    .ugc-grid {
      grid-template-columns: 1fr;
    }

    .chatbox-container {
      width: 94vw;
      right: 3vw;
    }

  }

  /* Default (desktop) */
  .industry-value {
    text-align: right;
  }

  /* Mobile only */
  @media (max-width: 480px) {
    .industry-value {
      width: 7rem;
      display: inline-block;
      text-align: right;
      white-space: normal;
      /* allow wrapping */
      word-break: break-word;
    }
  }

  /* Contact Modal Styling */
  .contact-modal {
    max-width: 460px;
  }

  .contact-title {
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 4px;
    text-align: center;
  }

  .contact-subtitle {
    text-align: center;
    font-size: 14px;
    color: #666;
    margin-bottom: 16px;
  }

  /* My Contact Card */
  .my-contact-card {
    background: #f9fafb;
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    padding: 12px;
    margin-bottom: 18px;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .contact-row {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 14px;
    color: #111827;
  }

  .contact-row i {
    font-size: 18px;
    color: #111827;
  }

  /* Mobile */
  @media (max-width: 480px) {
    .contact-modal {
      width: 92%;
    }
  }

  .msg.ai {
    background: #f3f4f6;
    color: #111827;
    font-size: 14px;
    line-height: 1.6;
  }

  .msg.ai strong {
    color: #111827;
  }

  .msg.ai p {
    margin: 0 0 8px 0;
  }

  .msg.ai br {
    line-height: 1.4;
  }
  /* ===========================================
   FULL-WIDTH IFRAME WITHOUT BREAKING LAYOUT
=========================================== */

/* Parent container stays normal */
.calendar-fullscreen {
  overflow-x: hidden;
}

/* Allow iframe section to escape wrapper */
.calendar-fullscreen iframe,
.calendar-embed-full {
  width: 100vw !important;
  max-width: 100vw !important;
  margin-left: calc(50% - 50vw) !important;
  margin-right: calc(50% - 50vw) !important;
  border: none;
  display: block;
}

/* Prevent right panel shrinking */
.bp-wrapper {
  max-width: 100%;
}

/* Keep panels normal */
.bp-left {
  flex: 0 0 50%;
}

.bp-right {
  flex: 0 0 50%;
}

/* Mobile */
@media (max-width: 640px) {

  .calendar-fullscreen iframe,
  .calendar-embed-full {
    width: 100vw !important;
    margin-left: calc(50% - 50vw) !important;
  }

}
/* ===============================
   PLYR THEME OVERRIDE
================================ */

/* Rounded player */
.plyr--video{
  border-radius:12px;
  overflow:hidden;
  background:#000;
}

/* Hide controls by default */
.plyr__controls{
  opacity:0;
  transform:translateY(10px);
  transition:.25s ease;
  background:linear-gradient(
    to top,
    rgba(0,0,0,.75),
    rgba(0,0,0,.15)
  );
}

/* Show on hover */
.media-card:hover .plyr__controls{
  opacity:1;
  transform:translateY(0);
}

/* Big center play */
.plyr__control--overlaid{
  background:rgba(0,0,0,.65);
  width:56px;
  height:56px;
}

.plyr__control--overlaid svg{
  width:22px;
  height:22px;
}

/* Progress bar */
.plyr__progress input[type=range]{
  color: var(--primary);
}

/* Buttons */
.plyr__controls button{
  color:#fff;
  opacity:.85;
}

.plyr__controls button:hover{
  color:#fff;
  opacity:1;
}

/* Time text */
.plyr__time{
  color:#ddd;
  font-size:12px;
}

/* Volume slider */
.plyr__volume input[type=range]{
  color: var(--primary);
}

/* Remove extra clutter */
.plyr__menu,
.plyr__captions{
  display:none !important;
}

/* Mobile always visible */
@media(max-width:768px){
  .plyr__controls{
    opacity:1 !important;
    transform:none !important;
  }
}
/* ================================
   HIDE CONTROLS BY DEFAULT
================================ */

.media-card .plyr__controls{
  opacity:0;
  pointer-events:none;
  transform:translateY(8px);
  transition:all .25s ease;
  background:linear-gradient(
    to top,
    rgba(0,0,0,.75),
    rgba(0,0,0,.2)
  );
}

/* SHOW ONLY ON HOVER */
.media-card:hover .plyr__controls{
  opacity:1;
  pointer-events:auto;
  transform:translateY(0);
}

/* CENTER PLAY BUTTON */
.plyr__control--overlaid{
  background:rgba(0,0,0,.65);
  width:54px;
  height:54px;
}

.plyr__control--overlaid svg{
  width:22px;
  height:22px;
}

/* BUTTON COLOR */
.plyr__controls button{
  color:#fff;
  opacity:.9;
}

.plyr__controls button:hover{
  opacity:1;
}

/* PROGRESS COLOR */
.plyr__progress input[type=range],
.plyr__volume input[type=range]{
  color: var(--primary);
}

/* MOBILE → ALWAYS VISIBLE */
@media(max-width:768px){
  .media-card .plyr__controls{
    opacity:1;
    pointer-events:auto;
    transform:none;
  }
}
.media-viewer {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999999;
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.media-viewer.active {
  visibility: visible;
  opacity: 1;
}

.mv-content {
  max-width: 95%;
  max-height: 95%;
  border-radius: 8px;
}

.media-viewer img {
  object-fit: contain;
}

.media-viewer video {
  object-fit: contain;
  background: black;
}

.mv-close {
  position: absolute;
  top: 20px;
  right: 30px;
  font-size: 40px;
  color: white;
  cursor: pointer;
  z-index: 2;
}
.media-viewer {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999999;
  animation: fadeIn 0.25s ease;
}

.mv-content {
  max-width: 95%;
  max-height: 95%;
  border-radius: 10px;
  object-fit: contain;
  background: black;
}

.mv-close {
  position: absolute;
  top: 20px;
  right: 30px;
  font-size: 40px;
  color: white;
  cursor: pointer;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}
/* Bigger modal for media */
.media-modal {
  width: 90vw;
  height: 90vh;
  max-width: 1100px;
  padding: 10px;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

/* Media scaling fix */
.mv-content {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

/* Close button */
.mv-close {
  position: absolute;
  top: 10px;
  right: 20px;
  font-size: 32px;
  color: white;
  cursor: pointer;
  z-index: 2;
}

</style>